// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* style-for-Profile-chart */
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

@font-face {
  font-family: "Conv_museo-500-webfont";
  src: url("https://assets.foursightonline.com/app/fonts/museo-500-webfont.eot");
  src: local("☺"), url("https://assets.foursightonline.com/app/fonts/museo-500-webfont.woff") format("woff"), url("https://assets.foursightonline.com/app/fonts/museo-500-webfont.ttf") format("truetype"), url("https://assets.foursightonline.com/app/fonts/museo-500-webfont.svg") format("svg");
  font-weight: normal;
  font-style: normal;
}
/*========== mixin for animation ====================*/
.chart-section {
  width: 90%;
  margin: 5% auto 0 auto;
  padding-bottom: 20px;
  /*------background colors used in chart---------*/
  /*------chart area wrapper---------*/
  /*------main chart wrapper---------*/
  /*------y dividers css---------*/
  /*------x dividers css---------*/
  /*------chart labels css---------*/
  /*------preferences css---------*/
  /*------neutral bar css---------*/
  /*------chart titles css---------*/
  /*------chart pointers css---------*/
  /*------chart pointers css end---------*/
  /*------connector css start---------*/
  /*------connector css end---------*/
}
.chart-section .chart-main {
  width: 100%;
  height: 250px;
  display: table;
  border-collapse: collapse;
  margin: 0 auto;
  float: none;
  position: relative;
}
.chart-section .y-dividers {
  display: table;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .chart-section .y-dividers {
    position: absolute;
  }
}
.chart-section .dividers-yxis {
  border-right: 1px solid #eee;
  border-collapse: collapse;
  display: table-cell;
  width: 20%;
  table-layout: fixed;
  position: relative;
}
.chart-section .dividers-yxis:first-child {
  border-left: 1px solid #eee;
}
.chart-section .x-dividers {
  display: block;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.owl-carousel .chart-section .x-dividers {
  backface-visibility: hidden;
}
.chart-section .dividers-xxis {
  border-collapse: collapse;
  width: 100%;
  height: 20%;
  border-bottom: 1px solid #eee;
  position: relative;
}
.chart-section .dividers-xxis:first-child {
  border-top: 1px solid #eee;
}
.chart-section .side-label {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.4) !important;
  position: absolute;
  left: -25px;
  top: -8px;
  text-align: right;
  width: 20px;
}
.chart-section .label-0 {
  position: absolute;
  top: inherit;
  bottom: -8px;
}
.chart-section .preference {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 30px;
  font-size: 16px;
  font-weight: 500;
}
.chart-section .high_prefer {
  position: absolute;
  top: 20px;
  color: rgba(0, 0, 0, 0.4) !important;
  left: 30px;
}
.chart-section .low_prefer {
  position: absolute;
  bottom: 20px;
  color: rgba(0, 0, 0, 0.4) !important;
  left: 30px;
}
.chart-section .neutral {
  display: block;
  margin-left: -30px;
  margin-right: -30px;
  background: #e3e3e3 !important;
  position: absolute;
  padding-left: 30px;
  padding-top: 5px;
  padding-bottom: 5px;
  z-index: 1;
  width: 100%;
  height: 30px;
  text-align: left;
}
.chart-section .neutral span {
  position: absolute;
  left: 0;
  font-size: 12px;
}
.chart-section .neutral_high_value {
  top: -15px;
}
.chart-section .neutral_low_value {
  bottom: -15px;
}
.chart-section .chart-title {
  text-transform: uppercase;
  font-size: 16px;
  color: #fff !important;
  display: inline-block;
  padding: 5px 0px;
  width: 110px;
  text-align: center;
  position: absolute;
  bottom: -31px;
  right: -55px;
  cursor: pointer;
  z-index: 99;
}
html.mac.safari .chart-section .chart-title {
  bottom: -45px;
}
.chart-section .chart-title.blue-bg:before,
.chart-section .chart-title.orange-bg:before,
.chart-section .chart-title.green-bg:before,
.chart-section .chart-title.purple-bg:before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  line-height: 0px;
  border-width: 0 55px 10px 55px;
  _filter: progid:DXImageTransform.Microsoft.Chroma(color="#000000");
}
.chart-section .chart_pointers {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}
.chart-section .pointer {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  left: 0;
  bottom: 0;
  color: #fff !important;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  line-height: 35px;
  transform: translateY(-50%);
  margin-bottom: -35px;
  font-weight: 600;
  font-family: "Helvetica LT W05 Bold" !important;
}
.chart-section .pointer.clarify_pointer {
  left: -ms-calc(20% - 17px);
  left: calc(20% - 17px);
}
.chart-section .pointer.ideate_pointer {
  left: -ms-calc(40% - 17px);
  left: -o-calc(40% - 17px);
  left: calc(40% - 17px);
}
.chart-section .pointer.develop_pointer {
  left: -ms-calc(60% - 17px);
  left: -o-calc(60% - 17px);
  left: calc(60% - 17px);
}
.chart-section .pointer.implement_pointer {
  left: -ms-calc(80% - 17px);
  left: -o-calc(80% - 17px);
  left: calc(80% - 17px);
}
.chart-section .connectors {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.chart-section .connector_block {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20%;
  z-index: 4;
}
.chart-section .block1 {
  margin-left: 20%;
}
.chart-section .block2 {
  margin-left: 60%;
}
.chart-section .block3 {
  margin-left: 40%;
}
.chart-section .connector_line {
  position: absolute;
  width: 8px;
  margin-top: -15px;
  background-color: #656668 !important;
}
.chart-section .connector_point {
  position: absolute;
  transform: translateY(-50%);
  width: 35px;
  height: 35px;
  margin-bottom: -35px;
}
.chart-section #connector_clarify_pointer,
.chart-section #connector_develop_pointer,
.chart-section #mid_connector_1 {
  left: -17px;
}
.chart-section #connector_ideate_pointer,
.chart-section #connector_implement_pointer,
.chart-section #mid_connector_2 {
  right: -17px;
}
.chart-section .hidden-xs {
  display: block;
}
.chart-section .visible-xs {
  display: none;
}
.chart-section .chart-title.sm .visible-xs {
  display: block !important;
}
.chart-section .chart-title.sm .hidden-xs {
  display: none !important;
}
.chart-section .chart-title.sm {
  width: 52px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  right: -25px;
  text-transform: capitalize;
  font-size: 14px;
}
.chart-section .chart-title.blue-bg.sm:before,
.chart-section .chart-title.orange-bg.sm:before,
.chart-section .chart-title.green-bg.sm:before,
.chart-section .chart-title.purple-bg.sm:before {
  border-width: 0 26px 10px 26px;
}
@media only screen and (max-width: 689px) {
  .chart-section #chartarea {
    min-width: 320px;
    padding-left: 15px;
  }
  .chart-section .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
  }
  .chart-section .chart-title.blue-bg:before,
  .chart-section .chart-title.orange-bg:before,
  .chart-section .chart-title.green-bg:before,
  .chart-section .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  .chart-section .chart-main {
    height: 300px;
    font-size: 14px;
  }
  .chart-section .chart-title,
  .chart-section .side-label,
  .chart-section .pointer {
    font-size: 14px;
  }
  .chart-section .connector_line {
    width: 5px;
  }
  .chart-section .hidden-xs {
    display: none;
  }
  .chart-section .visible-xs {
    display: block;
  }
}
@media only screen and (max-width: 767px) {
  .chart-section .chart-main {
    height: 280px;
  }
  ::ng-deep .result .chart-section .chart-main {
    height: 130px;
    margin-bottom: 30px;
  }
  .chart-section .chart-main .preference {
    font-size: 12px;
  }
  .chart-section .chart-main .high_prefer {
    top: 5px;
  }
  .chart-section .chart-main .low_prefer {
    bottom: 5px;
  }
  .chart-section .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
  }
  body.mini-navbar .chart-section .chart-title {
    width: 40px !important;
    right: -21px !important;
  }
  .chart-section .chart-title.blue-bg:before,
  .chart-section .chart-title.orange-bg:before,
  .chart-section .chart-title.green-bg:before,
  .chart-section .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  body.mini-navbar .chart-section .chart-title.blue-bg:before,
  body.mini-navbar .chart-section .chart-title.orange-bg:before,
  body.mini-navbar .chart-section .chart-title.green-bg:before,
  body.mini-navbar .chart-section .chart-title.purple-bg:before {
    border-width: 0 20px 10px 20px !important;
  }
  .chart-section .preference {
    font-size: 14px;
  }
  .chart-section .pointer {
    transform: translateY(-50%) scale(0.8);
  }
}
@media only screen and (max-width: 390px) {
  .chart-section #chartarea {
    min-width: 250px;
  }
  .chart-section .chart-title {
    width: 40px;
  }
  .chart-section .chart-title.blue-bg:before,
  .chart-section .chart-title.orange-bg:before,
  .chart-section .chart-title.green-bg:before,
  .chart-section .chart-title.purple-bg:before {
    border-width: 0 20px 10px 20px;
  }
}
@media only screen and (max-height: 600px) {
  .chart-section .chart-main {
    height: 250px;
    font-size: 14px;
  }
  .chart-section .chart-title,
  .chart-section .side-label,
  .chart-section .pointer {
    font-size: 14px;
  }
  .chart-section .chart-title.blue-bg:before,
  .chart-section .chart-title.orange-bg:before,
  .chart-section .chart-title.green-bg:before,
  .chart-section .chart-title.purple-bg:before {
    top: -10px;
  }
  .chart-section .connector_line {
    width: 5px;
  }
}

.print-info {
  display: block;
  font-size: 10px;
  margin-top: 5px;
  color: #676a6c;
  margin-bottom: 5px;
}
.print-info a {
  font-size: inherit !important;
}

#print-button {
  margin-bottom: -8px;
}
@media only screen and (max-width: 767px) {
  #print-button {
    margin: 0;
    width: 100%;
  }
  #print-button select,
  #print-button .btn {
    width: 100%;
  }
}

@media only screen and (max-height: 414px) and (orientation: landscape) {
  .chart-title.sm {
    width: 42px !important;
    right: -21px !important;
    font-size: 12px !important;
  }
  .chart-title.blue-bg.sm:before,
  .chart-title.orange-bg.sm:before,
  .chart-title.green-bg.sm:before,
  .chart-title.purple-bg.sm:before {
    border-width: 0 21px 10px 21px !important;
  }
}
.chart-container,
.below-chart {
  padding: 25px;
  max-width: 820px;
  width: 100%;
}

#print-button a {
  display: block;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 7px;
  text-align: right;
}

.interpretive-wrapper {
  max-width: 820px;
  width: 100%;
  font-family: "Museo-regular";
  margin-block-start: -60px;
}

.interpretive-wrapper .toolsguide {
  background: #fff;
}

section#four-profile {
  padding: 0;
}

.toolsguide {
  padding: 40px 40px 30px;
}

#four-profile .toolsguide-heading,
#four-profile .toolsguide-content {
  padding: 15px 30px;
}

.toolsguide .toolsguide-heading .toolsguide-heading-text {
  font-size: 40px;
  font-weight: 600;
}

#four-profile .toolsguide-heading,
#four-profile .toolsguide-content {
  padding: 15px 30px;
}

#four-think .box {
  margin: 15px 1%;
  min-height: 265px;
}

.toolsguide .box.clarify {
  border: 1px solid rgb(0, 173, 208) !important;
  box-shadow: 0 0 1px 0 rgb(0, 173, 208) !important;
}

#four-think .box h2 {
  border-bottom: 1px solid;
  box-shadow: 0 1px 1px -1px;
  padding-bottom: 5px;
}

.toolsguide .box.clarify h2,
.toolsguide .box.clarify h4 {
  color: rgb(0, 173, 208) !important;
}

.toolsguide .box h2 {
  font-size: 30px;
}

.toolsguide .toolsguide-content ul {
  padding: 0;
  list-style-position: inherit;
  list-style-type: none;
  font-family: "Museo-300";
}

.toolsguide .box ul {
  margin: 0;
  padding: 0;
  list-style-position: inside;
}

.toolsguide .box ul li {
  font-family: "Museo-300";
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 5px;
}

.toolsguide .toolsguide-content ul li {
  font-family: "Museo-300";
}

.toolsguide .toolsguide-content ul li:before {
  content: "•";
  margin-right: 5px;
}

.toolsguide .box.ideate {
  border: 1px solid rgb(255, 121, 0) !important;
  box-shadow: 0 0 1px 0 rgb(255, 121, 0) !important;
}

.toolsguide .box.ideate h2,
.toolsguide .box.ideate h4 {
  color: rgb(255, 121, 0) !important;
}

.toolsguide .box.develop {
  border: 1px solid rgb(105, 190, 40) !important;
  box-shadow: 0 0 1px 0 rgb(105, 190, 40) !important;
}

.toolsguide .box.develop h2,
.toolsguide .box.develop h4 {
  color: rgb(105, 190, 40) !important;
}

.toolsguide .box.implement {
  border: 1px solid rgb(245, 67, 89) !important;
  box-shadow: 0 0 1px 0 rgb(245, 67, 89) !important;
}

.toolsguide .box.implement h2,
.toolsguide .box.implement h4 {
  color: rgb(245, 67, 89) !important;
}

.toolsguide .toolsguide-heading .toolsguide-heading-text {
  font-size: 40px;
  font-weight: 600;
}

#four-box .box {
  margin: 15px 1%;
  min-height: 600px;
}

.toolsguide .box.clarify {
  border: 1px solid rgb(0, 173, 208) !important;
  box-shadow: 0 0 1px 0 rgb(0, 173, 208) !important;
}

.toolsguide .box .box-top {
  padding: 15px;
  margin: 0 -15px;
}

.toolsguide .box.clarify .box-top {
  background: rgb(0, 173, 208) !important;
}

.toolsguide .toolsguide-content h4 {
  font-size: 16px;
}

.toolsguide .box.ideate .box-top {
  background: rgb(255, 121, 0) !important;
}

.toolsguide .box.develop .box-top {
  background: rgb(105, 190, 40) !important;
}

.toolsguide .box h2 img {
  margin-left: 20px;
}

.toolsguide .box.implement .box-top {
  background: rgb(245, 67, 89) !important;
}

.toolsguide .toolsguide-content span.num {
  font-size: 28px;
  line-height: 20px;
  margin-top: 6px;
  display: block;
  width: 20px;
  float: left;
}

.toolsguide .toolsguide-content .num-p p {
  float: right;
  width: calc(100% - 30px);
  font-size: 14px;
}

.toolsguide .toolsguide-content h3 {
  font-size: 20px;
}

.pref {
  margin-top: 15px;
}

.toolsguide .toolsguide-content h4 {
  font-size: 16px;
}

.pref span {
  padding: 2px 4px;
  color: #fff !important;
  font-size: 14px;
}

.pref.clarify span {
  background: rgb(0, 173, 208) !important;
}

.pref.clarify ul li {
  color: rgb(0, 173, 208) !important;
}

.pref.ideate span {
  background: rgb(255, 121, 0) !important;
}

.pref.ideate ul li {
  color: rgb(255, 121, 0) !important;
}

.pref.developer span {
  background: rgb(105, 190, 40) !important;
}

.pref.developer ul li {
  color: rgb(105, 190, 40) !important;
}

.pref.implement span {
  background: rgb(245, 67, 89) !important;
}

.pref.implement ul li {
  color: rgb(245, 67, 89) !important;
}

.toolsguide .footer-xs {
  background-color: #e6e7e8;
  font-size: 12px !important;
  padding: 10px 40px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}

.fs-graph-logo {
  max-width: 300px;
  width: 100%;
}

.below-chart .left-label {
  background-color: #6d6e71 !important;
  float: left;
  font-size: 25px !important;
  line-height: 30px;
  letter-spacing: 0.8px;
  padding: 5px 11px 5px 11px !important;
  text-transform: none;
  font-family: "Helvetica LT W05 Bold";
  margin-bottom: 0 !important;
}

.below-chart .right-label {
  float: right;
  margin-bottom: 0 !important;
}
.below-chart .right-label .eq-developer {
  margin-bottom: 0 !important;
}

.right-label-text span.eq-clarifier {
  background-color: rgb(0, 173, 208) !important;
  display: none;
}

.right-label-text span .icon-plus {
  width: 32px;
  font-size: 14px;
  display: inline-block;
  text-align: center;
  color: #929394;
  display: inline-block;
  font: 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media (max-width: 992px) {
  .right-label-text span .icon-plus {
    width: 25px;
  }
}

.right-label-text .icon-plus:before {
  content: "\\f067";
}

.right-label-text .eq-developer {
  background-color: rgb(105, 190, 40) !important;
}

.below-chart span {
  color: #fff !important;
  padding: 10px;
}

.right-label-text .eq-ideator {
  background-color: rgb(255, 121, 0) !important;
}

.right-label-text .eq-implementer {
  background-color: rgb(245, 67, 89) !important;
}

@media (min-width: 768px) {
  #four-think .box {
    width: 48%;
  }
  #four-box .box {
    width: 48%;
  }
}
/*================= css copied from charts.scss ================*/
.comparison-chart-1 {
  border-left: 1px solid #c0c0c0;
  border-bottom: 1px solid #c0c0c0;
  height: 200px;
  position: relative;
  margin-top: 50px;
}
.comparison-chart-1 ul {
  padding: 0;
  margin: 0;
  display: flex;
}
.comparison-chart-1 ul li {
  list-style: none;
  width: 20%;
  margin: 0 2.5%;
  flex: 1;
  position: absolute;
  bottom: 0px;
}
.comparison-chart-1 ul li span {
  width: 50%;
  display: block;
  border: 0.5px solid #fff;
  float: left;
  position: absolute;
  bottom: 0;
}
.comparison-chart-1 ul li span .competitor-name {
  color: #fff;
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  margin: 0px;
  left: 2px;
}
.comparison-chart-1 ul li span .competitor-score {
  text-align: center;
  margin-top: -20px;
}
.comparison-chart-1 ul li span:last-child {
  margin-left: 50%;
  opacity: 0.7;
}
.comparison-chart-1 ul .clarify-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .clarify-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .clarify-comparison span:last-child {
  background-color: #ccc !important;
}
.comparison-chart-1 ul .ideate-comparison {
  margin-left: 25%;
}
.comparison-chart-1 ul .ideate-comparison span {
  background-color: rgb(255, 121, 0) !important;
}
.comparison-chart-1 ul.remove-color .ideate-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .ideate-comparison span:last-child {
  background-color: #ccc !important;
}
.comparison-chart-1 ul .develop-comparison {
  margin-left: 50%;
}
.comparison-chart-1 ul .develop-comparison span {
  background-color: rgb(105, 190, 40) !important;
}
.comparison-chart-1 ul.remove-color .develop-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .develop-comparison span:last-child {
  background-color: #ccc !important;
}
.comparison-chart-1 ul .implement-comparison {
  margin-left: 75%;
}
.comparison-chart-1 ul .implement-comparison span {
  background-color: rgb(245, 67, 89) !important;
}
.comparison-chart-1 ul.remove-color .implement-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .implement-comparison span:last-child {
  background-color: #ccc !important;
}

.client-detail .list-unstyled {
  width: 100%;
  float: left;
  margin-bottom: 35px;
}
@media screen and (max-width: 599px) {
  .client-detail .list-unstyled li {
    width: 100%;
  }
}
.client-detail .list-unstyled li h2 {
  font-size: 20px;
  font-weight: bold;
}
.client-detail .list-unstyled li span {
  font-size: 18px;
}
.client-detail .profile-headers {
  clear: both;
  float: left;
  width: 100%;
  margin: 30px 0;
  font-size: 18px;
  font-family: "Conv_museo-500-webfont";
}
@media (max-width: 767px) {
  .client-detail .profile-headers {
    font-size: 13px;
  }
}
.client-detail .profile-headers .profile-equation-wrapper {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media (max-width: 950px) {
  .client-detail .profile-headers .profile-equation-wrapper {
    float: left !important;
    clear: both;
    margin-top: 10px;
  }
}
@media (max-width: 767px) {
  .client-detail .profile-headers .profile-equation-wrapper {
    float: right !important;
    clear: none;
  }
}
@media (max-width: 599px) {
  .client-detail .profile-headers .profile-equation-wrapper {
    float: left !important;
    clear: both;
  }
}
.client-detail .profile-headers .profile-equation-wrapper span {
  color: #fff;
  padding: 7px;
}
@media (max-width: 950px) {
  .client-detail .profile-headers .profile-equation-wrapper span {
    float: left;
    margin-bottom: 10px;
  }
}
@media (max-width: 375px) {
  .client-detail .profile-headers .profile-equation-wrapper span {
    display: block;
  }
}
.client-detail .profile-headers .profile-equation-wrapper .eq-plus {
  color: #6d6e71;
}
.client-detail .profile-headers .profile-equation-result {
  background: #6d6e71;
  padding: 7px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.client-detail .profile-headers .profile-equation-result a {
  color: #fff;
  text-decoration: none;
}
.client-detail .client_description {
  clear: both;
  text-align: justify;
  font-size: 16px;
  margin-bottom: 30px;
  -ms-column-count: 2;
  column-count: 2;
  -ms-column-gap: 20;
  column-gap: 20;
}
@media screen and (max-width: 599px) {
  .client-detail .client_description {
    -ms-column-count: 1;
    column-count: 1;
    -ms-column-gap: 0;
    column-gap: 0;
  }
}
.client-detail .client_description span.pull-left {
  padding-right: 10px;
  padding-bottom: 10px;
}
.client-detail .client_description span.profile-desc {
  font-weight: bold;
}

.group-profile.teammates-group {
  height: 230px;
  border: none;
  max-width: 90%;
  margin: 0 auto;
}
.group-profile.teammates-group .main-group-profile {
  height: 230px;
}
.group-profile.teammates-group .main-group-profile .common-profile {
  max-height: 50px;
}
.group-profile.teammates-group .main-group-profile .integrators-region {
  height: 30px;
  margin-top: -15px;
}
.group-profile.teammates-group .main-group-profile .integrators-region h4 {
  line-height: 30px;
}
.group-profile.teammates-group .main-group-profile .profile-flex-bottom {
  margin-top: 15px;
}
.group-profile.teammates-group .main-group-profile .profile-flex-bottom .common-low h5 {
  margin: 0px;
  margin-top: 5px;
}
.group-profile.teammates-group .main-group-profile .profile-flex-top .common-high .top-label-scores {
  margin: 0;
  margin-bottom: 5px;
}

.comparison-chart-2 {
  border-left: 1px solid #c0c0c0;
  border-bottom: 1px solid #c0c0c0;
  height: 200px;
  position: relative;
}
.comparison-chart-2 .diff-score {
  position: absolute;
  color: #333;
  top: -20px;
}
.comparison-chart-2 .other-User .diff-score {
  right: -3px;
}
.comparison-chart-2 .current-User .diff-score {
  left: -3px;
}
.comparison-chart-2 .score_calculator {
  position: absolute;
  top: 0;
  left: -20px;
  bottom: 0;
  width: 20px;
}
.comparison-chart-2 .score_calculator .start,
.comparison-chart-2 .score_calculator .end {
  position: absolute;
}
.comparison-chart-2 .score_calculator .start {
  bottom: -5px;
  left: 7px;
}
.comparison-chart-2 .score_calculator .end {
  top: -5px;
}
.comparison-chart-2 ul {
  padding: 0;
  margin: 0 0 0 4.5%;
  display: flex;
  opacity: 0;
  animation-fill-mode: forwards;
  animation-name: chartOpacity;
  animation-duration: 3s;
  animation-timing-function: ease;
  animation-delay: 2000ms;
}
.comparison-chart-2 ul li {
  list-style: none;
  width: 20%;
  margin: 0;
  flex: 1;
  position: absolute;
  bottom: 0px;
}
.comparison-chart-2 ul li span {
  width: 50%;
  display: block;
  border: 0.5px solid #000;
  float: left;
  position: absolute;
  bottom: 0;
  z-index: 1;
  -ms-box-shadow: 2px 1px 5px rgba(0, 0, 0, 0.35);
  -o-box-shadow: 2px 1px 5px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 1px 5px rgba(0, 0, 0, 0.35);
}
.comparison-chart-2 ul li span .competitor-name {
  color: #fff;
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  margin: 0px;
  left: 2px;
}
.comparison-chart-2 ul li span .competitor-score {
  text-align: left;
  margin-top: 2px;
  color: #fff;
  margin-left: 3px;
  margin-right: 3px;
}
.comparison-chart-2 ul li span:last-child {
  opacity: 0.7;
  z-index: 0;
  left: 30%;
  -ms-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.comparison-chart-2 ul li span:last-child .competitor-name {
  right: 5px;
  left: inherit;
  text-align: right;
}
.comparison-chart-2 ul li span:last-child .competitor-score {
  text-align: right;
}
.comparison-chart-2 ul .clarify-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-2 ul .ideate-comparison {
  margin-left: 25%;
}
.comparison-chart-2 ul .ideate-comparison span {
  background-color: rgb(255, 121, 0) !important;
}
.comparison-chart-2 ul .develop-comparison {
  margin-left: 50%;
}
.comparison-chart-2 ul .develop-comparison span {
  background-color: rgb(105, 190, 40) !important;
}
.comparison-chart-2 ul .implement-comparison {
  margin-left: 75%;
}
.comparison-chart-2 ul .implement-comparison span {
  background-color: rgb(245, 67, 89) !important;
}

.grid {
  border-left: 1px solid #000;
  box-shadow: 0px 1px 0 rgb(0, 0, 0);
  border-top: 0;
  border-bottom: 0;
  width: 100%;
  max-width: 700px;
  height: 200px;
  margin: 50px auto;
  position: relative;
}
.grid .score_calculator {
  position: absolute;
  top: 0;
  left: -20px;
  bottom: 0;
  width: 20px;
}
.grid .score_calculator .start,
.grid .score_calculator .end {
  position: absolute;
}
.grid .score_calculator .start {
  bottom: -5px;
  left: 7px;
}
.grid .score_calculator .end {
  top: -5px;
}
.grid ul {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
.grid ul li {
  width: 25%;
  position: absolute;
  left: 0px;
  bottom: 0;
  top: 0px;
}
.grid ul li .commonGraph {
  opacity: 0.65;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 400ms ease-in-out;
}
.grid ul li .commonGraph:hover {
  opacity: 0.8;
}
.grid ul li .graph {
  z-index: 1;
}
.grid ul li .graph2 {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
}
.grid ul li.clarify-comparison .graph,
.grid ul li.clarify-comparison .graph2 {
  background: rgb(0, 173, 208);
}
.grid ul li.ideate-comparison {
  left: 25%;
}
.grid ul li.ideate-comparison .graph,
.grid ul li.ideate-comparison .graph2 {
  background: rgb(255, 121, 0);
}
.grid ul li.develop-comparison {
  left: 50%;
}
.grid ul li.develop-comparison .graph,
.grid ul li.develop-comparison .graph2 {
  background: rgb(105, 190, 40);
}
.grid ul li.implement-comparison {
  left: 75%;
}
.grid ul li.implement-comparison .graph,
.grid ul li.implement-comparison .graph2 {
  background: rgb(245, 67, 89);
}

::ng-deep .profile-section.chart-container__pd {
  padding: 0 !important;
  box-shadow: none !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .profile-section.chart-container__pd > h2 .form-inline {
    margin-top: 20px;
  }
}
::ng-deep .profile-section.chart-container__pd > h2 .form-inline input + input {
  margin-top: 10px;
}
::ng-deep .profile-section.chart-container__pd > h2 {
  display: flex;
  flex-direction: column-reverse;
}
@media only screen and (min-width: 768px) {
  ::ng-deep .profile-section.chart-container__pd > h2 span {
    text-align: right;
  }
}
::ng-deep .profile-section.chart-container__pd .chart-section {
  margin: 0 0 0 29px;
  width: 96.5%;
}
::ng-deep .profile-section .chart-section {
  margin-top: 0;
}
::ng-deep .profile-section .chart-section .side-label {
  font-size: 12px;
  line-height: 14px;
  color: #999999 !important;
  position: absolute;
  left: -35px !important;
  text-align: right;
  width: 20px;
  letter-spacing: 0.01px;
  font-family: "Helvetica LT W05 Light";
}
::ng-deep .profile-section .chart-section .high_prefer {
  position: absolute;
  top: 2px !important;
  left: 9px !important;
  width: 110px;
  font-weight: normal;
  font-size: 14px !important;
  line-height: 17px !important;
  font-family: "Helvetica LT W05 Roman";
  text-align: left;
  color: #5C5D60 !important;
}
::ng-deep .profile-section .chart-section .low_prefer {
  position: absolute;
  bottom: 20px;
  left: 9px;
  font-size: 14px;
  line-height: 17px;
  width: 110px;
  text-align: left;
  font-family: "Helvetica LT W05 Roman";
  color: #5C5D60 !important;
}
::ng-deep .profile-section .chart-section .neutral .neutralBartext {
  left: 9px !important;
  position: absolute;
  font-weight: normal;
  font-size: 14px !important;
  line-height: 17px !important;
  font-family: "Helvetica LT W05 Roman";
  color: #5C5D60 !important;
}
::ng-deep .profile-section .chart-section .neutral_high_value {
  font-size: 14px !important;
  font-weight: normal;
  line-height: 17px !important;
  font-family: "Helvetica LT W05 Roman";
  color: #999 !important;
  left: 9px !important;
}
::ng-deep .profile-section .chart-section .neutral_low_value {
  font-size: 14px !important;
  font-weight: normal;
  line-height: 17px !important;
  font-family: "Helvetica LT W05 Roman";
  color: #999 !important;
  left: 9px !important;
}
::ng-deep .profile-section .chart-section .chart-main .chart-title span {
  font-size: 11px !important;
  line-height: 14px;
  font-family: "Helvetica LT W05 Bold";
}
@media only screen and (max-width: 1023px) {
  ::ng-deep .profile-section .chart-section .chart-main .visible-xs {
    display: block !important;
  }
  ::ng-deep .profile-section .chart-section .chart-main .hidden-xs {
    display: none !important;
  }
  ::ng-deep .profile-section .chart-section .chart-main .chart-title.blue-bg:before,
  ::ng-deep .profile-section .chart-section .chart-main .chart-title.orange-bg:before,
  ::ng-deep .profile-section .chart-section .chart-main .chart-title.green-bg:before,
  ::ng-deep .profile-section .chart-section .chart-main .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  ::ng-deep .profile-section .chart-section .chart-main .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
    text-transform: capitalize;
    font-size: 14px;
  }
}
@media (min-width: 768px) {
  ::ng-deep .profile-section .chart-section .chart-main {
    height: 350px;
  }
}

@media (max-width: 1023px) {
  ::ng-deep #f-profile .chart-section .chart-main .visible-xs {
    display: block !important;
  }
  ::ng-deep #f-profile .chart-section .chart-main .hidden-xs {
    display: none !important;
  }
  ::ng-deep #f-profile .chart-section .chart-main .chart-title.blue-bg:before,
  ::ng-deep #f-profile .chart-section .chart-main .chart-title.orange-bg:before,
  ::ng-deep #f-profile .chart-section .chart-main .chart-title.green-bg:before,
  ::ng-deep #f-profile .chart-section .chart-main .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  ::ng-deep #f-profile .chart-section .chart-main .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
    text-transform: capitalize;
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  ::ng-deep #f-profile .chart-section .chart-main {
    height: 235px;
  }
}

::ng-deep .below-chart-description {
  background-color: #6d6e71 !important;
  color: #fff;
  padding: 25px 25px 0;
  max-width: 820px;
  width: 100%;
}
::ng-deep .below-chart-description .height30 {
  height: 30px;
}
::ng-deep .below-chart-description .custom-footer {
  margin-left: -25px;
  margin-right: -25px;
  background: #fff;
  color: #676a6c;
  display: flex;
  vertical-align: middle;
  align-items: center;
  padding: 15px 0px;
}
@media (max-width: 767px) {
  ::ng-deep .below-chart-description .custom-footer {
    display: block;
    float: left;
  }
  ::ng-deep .below-chart-description .custom-footer .col-xs-12 {
    text-align: center !important;
    margin-bottom: 10px;
  }
}
::ng-deep .below-chart-description .custom-footer p {
  margin: 0;
  font-size: 12px !important;
  color: #5C5D60 !important;
}
::ng-deep .below-chart-description .custom-footer a {
  font-size: 12px !important;
}

.quick-gd {
  width: 100%;
  max-width: 820px;
  position: relative;
  margin-block-start: -15px;
}
.quick-gd .quick-gd__arrow {
  border-left: 70px solid transparent;
  border-right: 70px solid transparent;
  border-top: 60px solid #7bbc43;
  max-width: 100px;
  position: relative;
  width: 100%;
  min-height: 100px;
  margin: 21px auto;
  cursor: pointer;
}
.quick-gd .quick-gd__arrow span {
  position: absolute;
  top: -60px;
  left: -20px;
  z-index: 9;
  max-width: 50px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}

#build-term .toolsguide-heading {
  min-height: 90px;
}
#build-term .lg-text {
  font-size: 18px;
  margin-bottom: 15px;
}
#build-term .side-bar {
  background: #e6e7e9 !important;
  padding: 20px;
}

#four-box .box {
  margin: 15px 1%;
  min-height: 600px;
}
@media (min-width: 768px) {
  #four-box .box {
    width: 48%;
  }
}
#four-box .box .col-xs-6:first-child {
  padding-right: 7.5px;
}
#four-box .box .col-xs-6:last-child {
  padding-left: 7.5px;
}

.right-button.text-right {
  width: 100%;
  text-align: center;
  margin: 3px 0 8px 0;
}
.right-button.text-right a.btn {
  /*width: 230px;*/
  display: block;
}
.right-button.disable-btn a {
  cursor: not-allowed;
}

.d-block {
  display: block;
}

.no-bottom-pad h5 {
  font-size: 17px;
}
.no-bottom-pad .close {
  margin-top: -24px;
}

.modal-dialog {
  width: 470px;
}

@media print {
  /*#chartarea {
      width: 580px;
    }*/
  .chart-title {
    color: #fff #fff !important;
  }
  .chart-title .visible-xs,
  .chart-title .hidden-xs {
    color: #fff #fff !important;
  }
  /* Guide Report print style*/
  body {
    color: #676a6c !important;
  }
  .below-chart,
  .below-chart-description {
    margin-left: 20px;
  }
  .below-chart-description p,
  .below-chart-description big,
  .below-chart-description a,
  .below-chart-description span,
  .below-chart-description sup {
    color: #fff !important;
  }
  .chart-container {
    padding-top: 0px;
    margin-bottom: 20px;
  }
  .short-guide .innovation-section,
  .long-guide .innovation-section {
    margin: 0px auto;
    padding: 15px 15px 50px;
    min-height: 960px;
  }
  .short-guide #four-profile,
  .long-guide #four-profile {
    padding-top: 0;
  }
  .short-guide #four-profile .toolsguide-heading,
  .long-guide #four-profile .toolsguide-heading {
    padding: 0px;
  }
  .short-guide #four-profile .toolsguide-content,
  .long-guide #four-profile .toolsguide-content {
    padding: 0;
  }
  .short-guide #four-box .box,
  .long-guide #four-box .box {
    min-height: 430px;
    margin: 0px 1% 15px;
  }
  .short-guide #four-box .box .box-top img,
  .long-guide #four-box .box .box-top img {
    width: 55px;
  }
  .short-guide #four-box .box h2,
  .long-guide #four-box .box h2 {
    margin: 5px 0;
  }
  .short-guide #four-box .box .col-xs-6:first-child,
  .long-guide #four-box .box .col-xs-6:first-child {
    padding: 0px 7.5px;
  }
  .short-guide #four-box .box ul li,
  .long-guide #four-box .box ul li {
    line-height: 16px;
  }
  .short-guide #four-think .box,
  .long-guide #four-think .box {
    min-height: 225px;
    margin: 2px;
  }
  .short-guide #dots-img,
  .long-guide #dots-img {
    background: url("https://assets.foursightonline.com/app/images/dotk.jpg") !important;
    background-size: cover !important;
    min-height: 900px;
  }
  .short-guide .toolsguide .box .box-top,
  .long-guide .toolsguide .box .box-top {
    padding: 0px 15px;
  }
  .short-guide #four-think .box h2,
  .long-guide #four-think .box h2 {
    margin: 5px 0;
  }
  .short-guide .toolsguide,
  .long-guide .toolsguide {
    page-break-after: always;
  }
  .short-guide .toolsguide:last-child,
  .long-guide .toolsguide:last-child {
    page-break-after: auto;
  }
  .short-guide .toolsguide .toolsguide-content aside,
  .long-guide .toolsguide .toolsguide-content aside {
    padding: 0px;
  }
  .short-guide .toolsguide .footer-lg,
  .long-guide .toolsguide .footer-lg {
    background-color: #6d6e71 !important;
  }
  .short-guide .toolsguide .footer-lg .text,
  .short-guide .toolsguide .footer-lg a,
  .long-guide .toolsguide .footer-lg .text,
  .long-guide .toolsguide .footer-lg a {
    color: #fff !important;
  }
  .short-guide .toolsguide .footer-lg a[href]:after,
  .long-guide .toolsguide .footer-lg a[href]:after {
    color: #fff !important;
  }
  .short-guide .toolsguide .pref.clarify span,
  .long-guide .toolsguide .pref.clarify span {
    background: #00aed9 !important;
  }
  .short-guide .toolsguide .pref.ideate span,
  .long-guide .toolsguide .pref.ideate span {
    background: #f68c1f !important;
  }
  .short-guide .toolsguide .pref.developer span,
  .long-guide .toolsguide .pref.developer span {
    background: #66bd4a !important;
  }
  .short-guide .toolsguide .pref.implement span,
  .long-guide .toolsguide .pref.implement span {
    background: #ef465b !important;
  }
  .short-guide .toolsguide .pref.clarify ul li,
  .long-guide .toolsguide .pref.clarify ul li {
    color: #00aed9 !important;
  }
  .short-guide .toolsguide .pref.developer ul li,
  .long-guide .toolsguide .pref.developer ul li {
    color: #66bd4a !important;
  }
  .short-guide .toolsguide .pref.ideate ul li,
  .long-guide .toolsguide .pref.ideate ul li {
    color: #f68c1f !important;
  }
  .short-guide .toolsguide .pref.implement ul li,
  .long-guide .toolsguide .pref.implement ul li {
    color: #ef465b !important;
  }
  .short-guide .toolsguide .toolsguide-heading-text,
  .long-guide .toolsguide .toolsguide-heading-text {
    margin: 0px;
  }
  .short-guide .toolsguide .footer-xs,
  .long-guide .toolsguide .footer-xs {
    background-color: #e6e7e8 !important;
  }
  .short-guide .toolsguide .box.clarify h2,
  .short-guide .toolsguide .box.clarify h4,
  .long-guide .toolsguide .box.clarify h2,
  .long-guide .toolsguide .box.clarify h4 {
    color: #00aed9 !important;
  }
  .short-guide .toolsguide .box.clarify .box-top,
  .long-guide .toolsguide .box.clarify .box-top {
    background-color: #00aed9 !important;
  }
  .short-guide .toolsguide .box.ideate h2,
  .short-guide .toolsguide .box.ideate h4,
  .long-guide .toolsguide .box.ideate h2,
  .long-guide .toolsguide .box.ideate h4 {
    color: #f68c1f !important;
  }
  .short-guide .toolsguide .box.ideate .box-top,
  .long-guide .toolsguide .box.ideate .box-top {
    background-color: #f68c1f !important;
  }
  .short-guide .toolsguide .box.develop h2,
  .short-guide .toolsguide .box.develop h4,
  .long-guide .toolsguide .box.develop h2,
  .long-guide .toolsguide .box.develop h4 {
    color: #66bd4a !important;
  }
  .short-guide .toolsguide .box.develop .box-top,
  .long-guide .toolsguide .box.develop .box-top {
    background-color: #66bd4a !important;
  }
  .short-guide .toolsguide .box.implement h2,
  .short-guide .toolsguide .box.implement h4,
  .long-guide .toolsguide .box.implement h2,
  .long-guide .toolsguide .box.implement h4 {
    color: #ef465b !important;
  }
  .short-guide .toolsguide .box.implement .box-top,
  .long-guide .toolsguide .box.implement .box-top {
    background-color: #ef465b !important;
  }
  .short-guide .toolsguide .box ul li,
  .long-guide .toolsguide .box ul li {
    margin-bottom: 0px;
  }
}
.profile-section h2 {
  color: #5C5D60;
  font-size: 32px;
  margin: 0 0 0;
  letter-spacing: -0.1px;
  font-family: "Helvetica LT W05 Bold";
}

.profile-section p {
  font-size: 12px !important;
  color: #5C5D60 !important;
  margin-bottom: 0;
}

.form-inline .fa,
.pencil .fa {
  font-size: 18px;
}

.grey {
  background: rgba(236, 236, 236, 0.9);
}

.download_language {
  margin-top: 20px;
  font-size: 13px;
}

.long_guides {
  margin-top: 20px;
}

.package-form {
  display: inline-block;
  width: 100%;
}
.package-form--pd .modal-body select {
  padding: 5px !important;
}
.package-form label,
.package-form select {
  width: 55%;
}
.package-form label {
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0 !important;
}
.package-form select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  margin-bottom: 10px;
}
.package-form select:focus {
  outline: none;
}
.package-form .modal-body .warning {
  padding-top: 10px;
}

.package-form .btn {
  margin-top: 10px;
}

.profile-description {
  color: #5C5D60 !important;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.4px;
  font-family: "Helvetica LT W05 Roman";
  margin-top: 13px;
}

.below-chart {
  background: #f1f1f1;
  margin-bottom: 0;
}
.below-chart h3 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px 13px;
}
.below-chart h3 .left-label {
  float: none;
}
.below-chart h3 .prefers_to {
  font-family: "Helvetica LT W05 Roman";
  color: #5C5D60 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  text-transform: none;
  letter-spacing: -0.04px;
  font-weight: normal;
  display: inline;
  margin-bottom: 0 !important;
}
.below-chart h3 #equation {
  display: inline-block;
}
.below-chart h3 #equation span {
  margin-bottom: 0 !important;
}
.below-chart h3 #equation > span {
  padding: 0;
  display: inline-block !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 14px !important;
  text-transform: uppercase !important;
  font-family: "Helvetica LT W05 Bold" !important;
  letter-spacing: 0.07px !important;
}

.footer-logo {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 10px;
}
.footer-logo .copyright {
  width: 50%;
}
.footer-logo .copyright p {
  font-size: 11px !important;
  letter-spacing: 0.39px !important;
}
.footer-logo .fs-logo {
  width: 50%;
  text-align: right;
}

.below-chart-description {
  margin-bottom: 0;
}
.below-chart-description p {
  margin: 0;
  font-family: "Helvetica LT W05 Light";
  font-size: 12px;
  line-height: 17px;
  display: block;
  color: #f1f1f1;
}
.below-chart-description p span {
  font-size: 14px;
  font-family: "Helvetica LT W05 Bold";
}
.below-chart-description .fs-graph-logo {
  max-width: 181px;
}

.fixed-loader {
  width: 100%;
  height: 100%;
  text-align: center;
}
.fixed-loader.profile-loader {
  max-width: 820px;
  width: 100%;
}
.fixed-loader i {
  font-size: 8em !important;
}

.pf-rdbtn {
  padding-bottom: 25px;
}
.pf-rdbtn--pfpdf {
  padding-bottom: 10px;
}
.pf-rdbtn label {
  padding: 0;
  width: 65%;
  padding-left: 10px;
  font-weight: 500;
  cursor: pointer;
}

.modal-body {
  padding-block-end: 0px;
}
.modal-body .disable-btn {
  pointer-events: none;
}
.modal-body .text-left.text {
  padding-left: 0;
}
.modal-body .text--fw {
  width: 100%;
  font-weight: bold;
  padding: 0;
}
.modal-body .assessment-select select {
  height: 30px;
  padding: 3px;
  width: 45%;
  background-color: #fff;
  margin: 0 10px 7px;
}

.modal-body__buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  width: calc(100% + 32px);
  margin: 0 -16px;
  padding: 5px 10px;
  background-color: #f6f6f6;
}
.modal-body__buttons .btn {
  margin-top: 0;
}
.modal-body__buttons .btn-prim {
  margin-inline-start: 10px;
}
.modal-body__buttons .btn-disable {
  cursor: not-allowed;
  pointer-events: none;
}

.clr {
  color: #5C5D60;
  font-size: 16px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
}
@media only screen and (max-width: 767px) {
  .clr {
    padding-bottom: 0;
  }
}
.clr select {
  padding: 2px 5px 2px 3px;
  outline-color: #5c5d60;
  width: 171px;
  height: 29px;
  color: #5c5d60;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media only screen and (max-width: 767px) {
  .clr select {
    width: 100%;
  }
}

.chart-container .chart-pfd {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  line-height: 20px;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  .chart-container .chart-pfd {
    flex-wrap: wrap;
  }
}
.chart-container .chart-pfd .chart-left {
  position: relative;
}
.chart-container .chart-pfd .chart-left__title {
  position: absolute;
  top: -55px;
}
@media only screen and (max-width: 767px) {
  .chart-container .chart-pfd .chart-left__title {
    position: static;
  }
}
.chart-container .chart-pfd .chart-left__title strong {
  padding-bottom: 8px;
  color: #5C5D60;
  font-size: 32px;
  line-height: 38px;
  margin: 0 0 0;
  letter-spacing: -0.1px;
  font-family: "Helvetica LT W05 Bold";
}
.chart-container .chart-pfd .chart-left__title .pencil {
  margin-left: 8px;
}
.chart-container .chart-pfd .chart-right {
  width: 100%;
  text-align: right;
  padding-bottom: 6px;
}
@media only screen and (max-width: 767px) {
  .chart-container .chart-pfd .chart-right {
    text-align: left;
  }
}
.chart-container .chart-pfd .chart-right .foursight-content {
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  margin-bottom: 0px;
  margin-top: 11px;
  letter-spacing: 0;
  padding-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .chart-container .chart-pfd .chart-right .foursight-content {
    text-align: left;
  }
}

.chartist-wrap__pd {
  margin: 0;
}

.section-wrapper {
  padding: 20px 10px 40px;
}

.guide-modal {
  display: none;
}

/*--- 05-07-23 ---*/
@media only screen and (max-width: 1199px) {
  .fs-profile .page-content .chart-container .chart-left__title h2 {
    font-size: 30px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .fs-profile .page-content .chart-container .chart-left__title h2 {
    font-size: 28px;
  }
}
@media (max-width: 640px) {
  .fs-profile .page-content .chart-container .chart-left__title h2 {
    font-size: 26px;
  }
}
@media (min-width: 641px) and (max-width: 991px) {
  ::ng-deep .fs-profile .page-content .chart-container__pd .chart-section {
    margin: 0 0 0 19px;
  }
}
@media (max-width: 640px) {
  ::ng-deep .fs-profile .page-content .chart-container__pd .chart-section {
    margin: 0 0 0 19px;
    width: 95%;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .fs-profile .page-content .below-chart h3 .left-label {
    font-size: 22px;
  }
}
@media (max-width: 640px) {
  .fs-profile .page-content .below-chart h3 .left-label {
    font-size: 18px !important;
    padding: 4px 8px !important;
    width: 100%;
    margin-right: 0 !important;
  }
}
@media (max-width: 640px) {
  .fs-profile .page-content .below-chart {
    padding: 18px;
  }
}
@media only screen and (max-width: 1199px) {
  .fs-profile .page-content .quick-gd .quick-gd__arrow {
    min-height: 75px;
  }
}

.f-btn--nobdr {
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fs-profile/fs-profile.component.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,4BAAA;ACgIA;EACE,eAAA;AD5HF;;AC+HA;EACE,aAAA;EACA,eAAA;AD5HF;;AC+HA;EACE,sBAAA;AD5HF;;AC+HA;EACE,8BAAA;AD5HF;;AC+HA;EACE,gBAAA;AD5HF;;AC+HA;EACE,gBAAA;AD5HF;;AC+HA;EACE,aAAA;AD5HF;;AC+HA;EACE,gBAAA;AD5HF;;AC0IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADvIJ;ACyII;;;;;;EACE,gBAAA;ADlIN;ACsIE;;EAEE,eA5GO;EA6GP,gBA3GO;ADzBX;ACsII;EALF;;IAMI,eA/GY;EDnBhB;AACF;ACqIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADlBX;ACqII;EALF;;IAMI,eArHY;EDZhB;AACF;ACoIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADXX;ACoII;EALF;;IAMI,eA3HY;EDLhB;AACF;ACmIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADJX;ACoIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADFX;ACqIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADAX;ACyIE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADvIJ;ACyII;EACE,gBAAA;ADvIN;AC0II;EAXF;IAYI,eAAA;EDvIJ;AACF;AC0IE;;EAEE,UAAA;EACA,SAAA;ADxIJ;AC2IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ADzIJ;;AC6IA;EACE,sBAxNQ;AD8EV;;AC6IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD1IF;AC4IE;EALF;IAMI,cAAA;EDzIF;AACF;AC2IE;EACE,iBA1Ka;ADiCjB;AC4IE;EACE,gBApLa;EAqLb,WAAA;AD1IJ;;AC+IE;EACE,kBAAA;AD5IJ;AC+IE;EACE,iBAAA;AD7IJ;;ACkJE;EACE,aAAA;AD/IJ;;ACmJA;EACE,kBAAA;ADhJF;ACkJE;EACE,mBAAA;ADhJJ;ACoJI;EACE,sBAAA;ADlJN;ACsJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;AD0EnB;ACsJI;EACE,sBAAA;ADpJN;ACuJI;EAVF;IAWI,eApOoB;EDgFxB;AACF;ACuJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADrJJ;ACuJI;EACE,sBAAA;ADrJN;ACwJI;EACE,WAAA;ADtJN;ACyJI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADqMZ;;AC4JA;EACE,mBA1PO;ADiGT;AC2JE;EAHF;IAII,mBAAA;EDxJF;AACF;AC0JE;EACE,mBAAA;ADxJJ;AC2JE;EACE,aArQK;AD4GT;AC2JI;EAHF;IAII,aAAA;EDxJJ;AACF;AC0JI;EACE,aAAA;ADxJN;;AC6JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD1JF;AC4JE;EACE,eAAA;AD1JJ;AC6JE;EACE,sCAAA;AD3JJ;AC8JE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD5JJ;;AC2KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ADxKJ;AC0KI;EACE,kBAAA;ADxKN;AC2KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ADzKN;;AC8KA;EACE,8BAAA;AD3KF;;AC8KA;EACE,8BAAA;AD3KF;;AC8KA;EACE,+BAAA;AD3KF;;AC8KA;EACE,8BAAA;AD3KF;;AC8KA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD3KF;AC6KE;EACE,2BAAA;EACA,mBAAA;AD3KJ;AC8KE;EACE,yBAzbiB;EA0bjB,WA1aO;AD8PX;AC+KE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD7KJ;ACgLE;EACE,yBAjckB;EAkclB,cArciB;ADuRrB;ACiLE;EACE,yBAvbS;EAwbT,WA1bO;AD2QX;ACiLI;EACE,6BAAA;AD/KN;;ACoLA;EACE;IACE,uBAAA;EDjLF;ECoLA;IACE,yBAAA;EDlLF;AACF;ACqLA;EACE,8BAAA;ADnLF;;ACsLA;EACE,8BAAA;ADnLF;;ACsLA;EACE,+BAAA;ADnLF;;ACsLA;EACE,8BAAA;ADnLF;;ACsLA;EACE,qBAAA;ADnLF;;ACsLA;EACE,UAAA;ADnLF;ACqLE;EACE,qBAAA;ADnLJ;;ACuLA;EACE,UAAA;ADpLF;;ACwLE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADtLJ;ACyLM;EACE,mBAAA;ADvLR;AC4LE;EACE,2BAAA;AD1LJ;AC6LE;EACE,uBAAA;AD3LJ;AC8LE;EACE,mBAAA;AD5LJ;;ACiME;EACE,mBAAA;AD9LJ;ACiME;EACE,yBAAA;AD/LJ;ACkME;EACE,sBAAA;ADhMJ;ACmME;EACE,uBAAA;ADjMJ;ACoME;EACE,oBAAA;ADlMJ;;AA3YA;EACE,qCAAA;EACA,8EAAA;EACA,iSAAA;EACA,mBAAA;EACA,kBAAA;AA8YF;AAjYA,sDAAA;AA2CA;EAIE,UAAA;EACA,sBAAA;EACA,oBAAA;EAEA,iDAAA;EAcA,oCAAA;EAEA,oCAAA;EAWA,gCAAA;EA+BA,gCAAA;EA4BA,kCAAA;EAiBA,iCAAA;EA0BA,iCAAA;EAiCA,kCAAA;EAqDA,oCAAA;EAsDA,wCAAA;EAEA,qCAAA;EA0DA,mCAAA;AAwBF;AAhVE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAkVJ;AA9UE;EACE,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EAEA,SAAA;EACA,QAAA;AA+UJ;AA5UE;EAEE;IACE,kBAAA;EA6UJ;AACF;AA1UE;EACE,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AA4UJ;AAzUE;EACE,2BAAA;AA2UJ;AAvUE;EACE,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AAyUJ;AAvUI;EAEE,2BAAA;AAyUN;AArUE;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;AAuUJ;AApUE;EACE,0BAAA;AAsUJ;AAlUE;EACE,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AAoUJ;AAjUE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AAmUJ;AA/TE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAiUJ;AA9TE;EACE,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;AAgUJ;AA7TE;EACE,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;AA+TJ;AA3TE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAIA,gBAAA;AA0TJ;AAvTE;EACE,kBAAA;EACA,OAAA;EACA,eAAA;AAyTJ;AAtTE;EACE,UAAA;AAwTJ;AArTE;EACE,aAAA;AAuTJ;AAnTE;EACE,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAqTJ;AAnTI;EACE,aAAA;AAqTN;AAjTE;;;;EAIE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;GAmTF,iEAlTE;AAmTJ;AA9RE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAgSJ;AA7RE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EAGA,2BAAA;EACA,oBAAA;EACA,gBAAA;EACA,+CAAA;AA+RJ;AA5RE;EACE,0BAAA;EACA,sBAAA;AA8RJ;AA3RE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AA6RJ;AA1RE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AA4RJ;AAzRE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AA2RJ;AArRE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AAuRJ;AApRE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAsRJ;AAnRE;EACE,gBAAA;AAqRJ;AAlRE;EACE,gBAAA;AAoRJ;AAjRE;EACE,gBAAA;AAmRJ;AAhRE;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,oCAAA;AAkRJ;AA/QE;EACE,kBAAA;EAGA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAiRJ;AA9QE;;;EAGE,WAAA;AAgRJ;AA7QE;;;EAGE,YAAA;AA+QJ;AA1QE;EACE,cAAA;AA4QJ;AAzQE;EACE,aAAA;AA2QJ;AAxQE;EACE,yBAAA;AA0QJ;AAvQE;EACE,wBAAA;AAyQJ;AAtQE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;AAwQJ;AArQE;;;;EAIE,8BAAA;AAuQJ;AApQE;EACE;IACE,gBAAA;IACA,kBAAA;EAsQJ;EAnQE;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EAqQJ;EAlQE;;;;IAIE,8BAAA;EAoQJ;EAjQE;IACE,aAAA;IACA,eAAA;EAmQJ;EAhQE;;;IAGE,eAAA;EAkQJ;EA/PE;IACE,UAAA;EAiQJ;EA9PE;IACE,aAAA;EAgQJ;EA7PE;IACE,cAAA;EA+PJ;AACF;AA5PE;EACE;IACE,aAAA;EA8PJ;EA5PI;IACE,aAAA;IACA,mBAAA;EA8PN;EA3PI;IACE,eAAA;EA6PN;EA1PI;IACE,QAAA;EA4PN;EAzPI;IACE,WAAA;EA2PN;EAtOE;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EAwOJ;EAtOI;IACE,sBAAA;IACA,uBAAA;EAwON;EApOE;;;;IAIE,8BAAA;EAsOJ;EApOI;;;;IACE,yCAAA;EAyON;EArOE;IACE,eAAA;EAuOJ;EApOE;IAKE,sCAAA;EAsOJ;AACF;AAnOE;EACE;IACE,gBAAA;EAqOJ;EAlOE;IACE,WAAA;EAoOJ;EAjOE;;;;IAIE,8BAAA;EAmOJ;AACF;AAhOE;EACE;IACE,aAAA;IACA,eAAA;EAkOJ;EA/NE;;;IAGE,eAAA;EAiOJ;EA9NE;;;;IAIE,UAAA;EAgOJ;EA7NE;IACE,UAAA;EA+NJ;AACF;;AA3NA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,cC9jBmB;ED+jBnB,kBAAA;AA8NF;AA5NE;EACE,6BAAA;AA8NJ;;AA1NA;EAEE,mBAAA;AA4NF;AA1NE;EAJF;IAKI,SAAA;IACA,WAAA;EA6NF;EA3NE;;IAEE,WAAA;EA6NJ;AACF;;AAxNA;EAEE;IACE,sBAAA;IACA,uBAAA;IACA,0BAAA;EA0NF;EAvNA;;;;IAIE,yCAAA;EAyNF;AACF;AAtNA;;EAEE,aAAA;EACA,gBAAA;EACA,WAAA;AAwNF;;AArNA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAwNF;;AArNA;EACE,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,yBAAA;AAwNF;;AArNA;EACE,gBCzlBiB;ADizBnB;;AArNA;EACE,UAAA;AAwNF;;AArNA;EACE,uBAAA;AAwNF;;AArNA;;EAEE,kBAAA;AAwNF;;AArNA;EACE,eAAA;EACA,gBAAA;AAwNF;;AArNA;;EAEE,kBAAA;AAwNF;;AArNA;EACE,eAAA;EACA,iBAAA;AAwNF;;AArNA;EACE,6CAAA;EACA,iDAAA;AAwNF;;AArNA;EACE,wBAAA;EACA,0BAAA;EACA,mBAAA;AAwNF;;AArNA;;EAEE,kCAAA;AAwNF;;AArNA;EACE,eAAA;AAwNF;;AArNA;EACE,UAAA;EACA,4BAAA;EACA,qBAAA;EACA,wBAAA;AAwNF;;AArNA;EACE,SAAA;EACA,UAAA;EACA,2BAAA;AAwNF;;AArNA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAwNF;;AArNA;EACE,wBAAA;AAwNF;;AArNA;EACE,YAAA;EACA,iBAAA;AAwNF;;AArNA;EACE,6CAAA;EACA,iDAAA;AAwNF;;AArNA;;EAEE,kCAAA;AAwNF;;AArNA;EACE,8CAAA;EACA,kDAAA;AAwNF;;AArNA;;EAEE,mCAAA;AAwNF;;AArNA;EACE,6CAAA;EACA,iDAAA;AAwNF;;AArNA;;EAEE,kCAAA;AAwNF;;AArNA;EACE,eAAA;EACA,gBAAA;AAwNF;;AArNA;EACE,eAAA;EACA,iBAAA;AAwNF;;AArNA;EACE,6CAAA;EACA,iDAAA;AAwNF;;AArNA;EACE,aAAA;EACA,eAAA;AAwNF;;AArNA;EACE,uCAAA;AAwNF;;AArNA;EACE,eAAA;AAwNF;;AArNA;EACE,uCAAA;AAwNF;;AArNA;EACE,wCAAA;AAwNF;;AArNA;EACE,iBAAA;AAwNF;;AArNA;EACE,uCAAA;AAwNF;;AArNA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;AAwNF;;AArNA;EACE,YAAA;EACA,wBAAA;EACA,eAAA;AAwNF;;AArNA;EACE,eAAA;AAwNF;;AArNA;EACE,gBAAA;AAwNF;;AArNA;EACE,eAAA;AAwNF;;AArNA;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;AAwNF;;AArNA;EACE,uCAAA;AAwNF;;AArNA;EACE,kCAAA;AAwNF;;AArNA;EACE,uCAAA;AAwNF;;AArNA;EACE,kCAAA;AAwNF;;AArNA;EACE,wCAAA;AAwNF;;AArNA;EACE,mCAAA;AAwNF;;AArNA;EACE,uCAAA;AAwNF;;AArNA;EACE,kCAAA;AAwNF;;AArNA;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;AAwNF;;AArNA;EACE,gBAAA;EACA,WAAA;AAwNF;;AArNA;EACE,oCAAA;EACA,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,qBAAA;EACA,qCAAA;EACA,oBAAA;EACA,oCAAA;EACA,2BAAA;AAwNF;;AArNA;EACE,YAAA;EACA,2BAAA;AAwNF;AAtNE;EACE,2BAAA;AAwNJ;;AApNA;EACE,6CAAA;EACA,aAAA;AAuNF;;AApNA;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AAuNF;AArNE;EAbF;IAcI,WAAA;EAwNF;AACF;;AArNA;EACE,gBAAA;AAwNF;;AArNA;EACE,8CAAA;AAwNF;;AArNA;EACE,sBAAA;EACA,aAAA;AAwNF;;AArNA;EACE,6CAAA;AAwNF;;AArNA;EACE,6CAAA;AAwNF;;AApNA;EACE;IACE,UAAA;EAuNF;EApNA;IACE,UAAA;EAsNF;AACF;AAnNA,iEAAA;AAEA;EACE,8BAAA;EACA,gCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAoNF;AAlNE;EACE,UAAA;EACA,SAAA;EACA,aAAA;AAoNJ;AAlNI;EACE,gBAAA;EACA,UAAA;EACA,cAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AAoNN;AAlNM;EACE,UAAA;EACA,cAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AAoNR;AAlNQ;EACE,WC/6BS;EDg7BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAoNV;AAjNQ;EACE,kBAAA;EACA,iBAAA;AAmNV;AA/MM;EACE,gBAAA;EACA,YAAA;AAiNR;AA5MM;EACE,6CAAA;AA8MR;AAzMM;EACE,6CAAA;AA2MR;AAxMM;EACE,iCAAA;AA0MR;AAtMI;EACE,gBAAA;AAwMN;AAtMM;EACE,6CAAA;AAwMR;AAnMM;EACE,6CAAA;AAqMR;AAlMM;EACE,iCAAA;AAoMR;AAhMI;EACE,gBAAA;AAkMN;AAhMM;EACE,8CAAA;AAkMR;AA7LM;EACE,6CAAA;AA+LR;AA5LM;EACE,iCAAA;AA8LR;AA1LI;EACE,gBAAA;AA4LN;AA1LM;EACE,6CAAA;AA4LR;AAvLM;EACE,6CAAA;AAyLR;AAtLM;EACE,iCAAA;AAwLR;;AAjLE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;AAoLJ;AA9KM;EAJF;IAKI,WAAA;EAiLN;AACF;AA/KM;EACE,eAAA;EACA,iBAAA;AAiLR;AA9KM;EACE,eAAA;AAgLR;AA3KE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,qCCvmCS;ADoxCb;AA3KI;EARF;IASI,eAAA;EA8KJ;AACF;AA5KI;EACE,wECxnCO;ADsyCb;AA5KM;EAHF;IAII,sBAAA;IACA,WAAA;IACA,gBAAA;EA+KN;AACF;AA7KM;EATF;IAUI,uBAAA;IACA,WAAA;EAgLN;AACF;AA9KM;EAdF;IAeI,sBAAA;IACA,WAAA;EAiLN;AACF;AA/KM;EACE,WCpkCW;EDqkCX,YAAA;AAiLR;AA/KQ;EAJF;IAKI,WAAA;IACA,mBAAA;EAkLR;AACF;AAhLQ;EATF;IAUI,cAAA;EAmLR;AACF;AAhLM;EACE,cCjnCa;ADmyCrB;AA9KI;EACE,mBCtnCe;EDunCf,YAAA;EACA,wEChqCO;ADg1Cb;AA9KM;EACE,WC5lCW;ED6lCX,qBAAA;AAgLR;AA7IE;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,cAAA;AA+IJ;AA7II;EAdF;IAgBI,mBAAA;IAEA,eAAA;IAEA,iBAAA;IAEA,aAAA;EAgJJ;AACF;AA9II;EACE,mBAAA;EACA,oBAAA;AAgJN;AA7II;EACE,iBAAA;AA+IN;;AA1IA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA6IF;AA3IE;EACE,aAAA;AA6IJ;AA3II;EACE,gBAAA;AA6IN;AA1II;EACE,YAAA;EACA,iBAAA;AA4IN;AA1IM;EACE,iBAAA;AA4IR;AAxII;EACE,gBAAA;AA0IN;AAvIQ;EACE,WAAA;EACA,eAAA;AAyIV;AAlIQ;EACE,SAAA;EACA,kBAAA;AAoIV;;AA5HA;EACE,8BAAA;EACA,gCAAA;EACA,aAAA;EACA,kBAAA;AA+HF;AA7HE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AA+HJ;AA3HI;EACE,WAAA;AA6HN;AAxHI;EACE,UAAA;AA0HN;AAtHE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AAwHJ;AAtHI;;EAEE,kBAAA;AAwHN;AArHI;EACE,YAAA;EACA,SAAA;AAuHN;AApHI;EACE,SAAA;AAsHN;AAjHE;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EA3wCF,6BA4wC+B;EA1yC/B,4BA2yC0B;EAtyC1B,sBAuyC8B;EAlyC9B,+BAmyCqC;EA9xCrC,uBA+xC2B;AAwH7B;AAtHI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AAwHN;AAtHM;EACE,UAAA;EACA,cAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EAh1CJ,+CAi1CgC;EAj1ChC,8CAi1CgC;EA70ClC,2CA60CkC;AA4HpC;AA1HQ;EACE,WC9xCS;ED+xCT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AA4HV;AAzHQ;EACE,gBAAA;EACA,eAAA;EACA,WCzyCS;ED0yCT,gBAAA;EACA,iBAAA;AA2HV;AAvHM;EACE,YAAA;EACA,UAAA;EACA,SAAA;EAx2CJ,oBAy2CgC;EAz2ChC,mBAy2CgC;EAr2ClC,gBAq2CkC;AA6HpC;AA3HQ;EACE,UAAA;EACA,aAAA;EACA,iBAAA;AA6HV;AA1HQ;EACE,iBAAA;AA4HV;AAtHM;EACE,6CAAA;AAwHR;AApHI;EACE,gBAAA;AAsHN;AApHM;EACE,6CAAA;AAsHR;AAlHI;EACE,gBAAA;AAoHN;AAlHM;EACE,8CAAA;AAoHR;AAhHI;EACE,gBAAA;AAkHN;AAhHM;EACE,6CAAA;AAkHR;;AAjGA;EACE,2BAAA;EACA,kCAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAoGF;AAlGE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AAoGJ;AAlGI;;EAEE,kBAAA;AAoGN;AAjGI;EACE,YAAA;EACA,SAAA;AAmGN;AAhGI;EACE,SAAA;AAkGN;AA7FE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA+FJ;AA7FI;EACE,UAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;AA+FN;AA7FM;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAn9CN,iCAo9CkC;AAkGpC;AAhGQ;EACE,YAAA;AAkGV;AA9FM;EACE,UAAA;AAgGR;AA7FM;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;AA+FR;AA1FQ;;EAEE,4BC1+CM;ADskDhB;AArDM;EACE,SAAA;AAuDR;AArDQ;;EAEE,4BCrhDK;AD4kDf;AAjBM;EACE,SAAA;AAmBR;AAjBQ;;EAEE,6BC/jDM;ADklDhB;AAkBM;EACE,SAAA;AAhBR;AAkBQ;;EAEE,4BCxmDQ;ADwlDlB;;AA4DI;EACE,qBAAA;EACA,2BAAA;AAzDN;AA6DQ;EAFF;IAGI,gBAAA;EA1DR;AACF;AA4DQ;EACE,gBAAA;AA1DV;AA8DM;EAEE,aAAA;EACA,8BAAA;AA7DR;AAiEU;EAFF;IAGI,iBAAA;EA9DV;AACF;AAmEM;EACE,kBAAA;EACA,YAAA;AAjER;AAuEE;EACE,aAAA;AArEJ;AAuEI;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,qCAAA;AArEN;AAwEI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qCAAA;EACA,gBAAA;EACA,yBAAA;AAtEN;AAyEI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;EACA,yBAAA;AAvEN;AA0EI;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qCAAA;EACA,yBAAA;AAxEN;AA2EI;EACE,0BAAA;EACA,mBAAA;EACA,4BAAA;EACA,qCAAA;EACA,sBAAA;EACA,oBAAA;AAzEN;AA4EI;EACE,0BAAA;EACA,mBAAA;EACA,4BAAA;EACA,qCAAA;EACA,sBAAA;EACA,oBAAA;AA1EN;AA8EM;EACE,0BAAA;EACA,iBAAA;EACA,oCAAA;AA5ER;AA+EM;EACE;IACE,yBAAA;EA7ER;EAgFM;IACE,wBAAA;EA9ER;EAiFM;;;;IAIE,8BAAA;EA/ER;EAkFM;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,0BAAA;IACA,eAAA;EAhFR;AACF;AAmFM;EAnCF;IAoCI,aAAA;EAhFN;AACF;;AAwFM;EACE;IACE,yBAAA;EArFR;EAwFM;IACE,wBAAA;EAtFR;EAyFM;;;;IAIE,8BAAA;EAvFR;EA0FM;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,0BAAA;IACA,eAAA;EAxFR;AACF;AA2FM;EA7BF;IA8BI,aAAA;EAxFN;AACF;;AA6FA;EACE,oCAAA;EACA,WChyDiB;EDiyDjB,oBAAA;EACA,gBAAA;EACA,WAAA;AA1FF;AA4FE;EACE,YAAA;AA1FJ;AA6FE;EACE,kBAAA;EACA,mBAAA;EACA,gBC5yDe;ED6yDf,cCj1DiB;EDo1DjB,aAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AA3FJ;AA6FI;EAdF;IAeI,cAAA;IACA,WAAA;EA1FJ;EA4FI;IACE,6BAAA;IACA,mBAAA;EA1FN;AACF;AA6FI;EACE,SAAA;EACA,0BAAA;EACA,yBAAA;AA3FN;AA8FI;EACE,0BAAA;AA5FN;;AAkGA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AA/FF;AAiGE;EACE,mCAAA;EACA,oCAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AA/FJ;AAiGI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AA/FN;;AAqGE;EACE,gBAAA;AAlGJ;AAqGE;EACE,eAAA;EACA,mBAAA;AAnGJ;AAsGE;EACE,8BAAA;EACA,aAAA;AApGJ;;AAwGA;EAKE,eAAA;EACA,iBAAA;AAzGF;AAoGE;EADF;IAEI,UAAA;EAjGF;AACF;AAuGI;EACE,oBAAA;AArGN;AAwGI;EACE,mBAAA;AAtGN;;AA6GE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AA1GJ;AA4GI;EACE,gBAAA;EACA,cAAA;AA1GN;AA+GI;EACE,mBAAA;AA7GN;;AAmHA;EACE,cAAA;AAhHF;;AAsHE;EACE,eAAA;AAnHJ;AAsHE;EACE,iBAAA;AApHJ;;AAwHA;EACE,YAAA;AArHF;;AAwHA;EAEE;;MAAA;EAGA;IACE,2BAAA;EAtHF;EAwHE;;IAEE,2BAAA;EAtHJ;EA0HA,4BAAA;EAEA;IACE,yBAAA;EAzHF;EA4HA;;IAEE,iBAAA;EA1HF;EAgIE;;;;;IAKE,sBAAA;EA9HJ;EAkIA;IACE,gBAAA;IACA,mBAAA;EAhIF;EAqIE;;IACE,gBAAA;IACA,uBAAA;IACA,iBAAA;EAlIJ;EAqIE;;IACE,cAAA;EAlIJ;EAoII;;IACE,YAAA;EAjIN;EAoII;;IACE,UAAA;EAjIN;EAqIE;;IACE,iBAAA;IACA,mBAAA;EAlIJ;EAqIM;;IACE,WAAA;EAlIR;EAsII;;IACE,aAAA;EAnIN;EAsII;;IACE,kBAAA;EAnIN;EAsII;;IACE,iBAAA;EAnIN;EAuIE;;IACE,iBAAA;IACA,WAAA;EApIJ;EAuIE;;IACE,oFAAA;IACA,iCAAA;IACA,iBAAA;EApIJ;EAuIE;;IACE,iBAAA;EApIJ;EAuIE;;IACE,aAAA;EApIJ;EAuIE;;IACE,wBAAA;EApIJ;EAsII;;IACE,sBAAA;EAnIN;EAsII;;IACE,YAAA;EAnIN;EAsII;;IACE,oCAAA;EAnIN;EAqIM;;;;IAEE,sBAAA;EAjIR;EAoIM;;IACE,sBAAA;EAjIR;EAqII;;IACE,8BAAA;EAlIN;EAsII;;IACE,8BAAA;EAnIN;EAsII;;IACE,8BAAA;EAnIN;EAsII;;IACE,8BAAA;EAnIN;EAsII;;IACE,yBAAA;EAnIN;EAsII;;IACE,yBAAA;EAnIN;EAsII;;IACE,yBAAA;EAnIN;EAsII;;IACE,yBAAA;EAnIN;EAsII;;IACE,WAAA;EAnIN;EAsII;;IACE,oCAAA;EAnIN;EAwIM;;;;IAEE,yBAAA;EApIR;EAuIM;;IACE,oCAAA;EApIR;EA0IM;;;;IAEE,yBAAA;EAtIR;EAyIM;;IACE,oCAAA;EAtIR;EA4IM;;;;IAEE,yBAAA;EAxIR;EA2IM;;IACE,oCAAA;EAxIR;EA8IM;;;;IAEE,yBAAA;EA1IR;EA6IM;;IACE,oCAAA;EA1IR;EA8II;;IACE,kBAAA;EA3IN;AACF;AAgJA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;AA9IF;;AAiJA;EACE,0BAAA;EACA,yBAAA;EACA,gBAAA;AA9IF;;AAiJA;;EAEE,eAAA;AA9IF;;AAiJA;EACE,oCAAA;AA9IF;;AAiJA;EACE,gBAAA;EACA,eAAA;AA9IF;;AAiJA;EACE,gBAAA;AA9IF;;AAiJA;EACE,qBAAA;EACA,WAAA;AA9IF;AAoJM;EACE,uBAAA;AAlJR;AAuJE;;EAEE,UAAA;AArJJ;AAwJE;EACE,gBAAA;EACA,6CAAA;AAtJJ;AAyJE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;AAvJJ;AA0JE;EACE,aAAA;AAxJJ;AA2JE;EACE,iBAAA;AAzJJ;;AA6JA;EACE,gBAAA;AA1JF;;AA6JA;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,qCAAA;EACA,gBAAA;AA1JF;;AA6JA;EACE,mBAAA;EACA,gBAAA;AA1JF;AA4JE;EAGE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AA1JJ;AA4JI;EACE,WAAA;AA1JN;AA+JI;EACE,qCAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AA7JN;AAgKI;EACE,qBAAA;AA9JN;AAiKM;EACE,2BAAA;AA/JR;AAkKM;EACE,UAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,oCAAA;EACA,+CAAA;EACA,iCAAA;AAhKR;;AAsKA;EAGE,aAAA;EAEA,eAAA;EAGA,qBAAA;EACA,WAAA;EACA,mBAAA;AAnKF;AAqKE;EACE,UAAA;AAnKJ;AAqKI;EACE,0BAAA;EACA,iCAAA;AAnKN;AAuKE;EACE,UAAA;EACA,iBAAA;AArKJ;;AAyKA;EACE,gBAAA;AAtKF;AAwKE;EACE,SAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAtKJ;AAwKI;EACE,eAAA;EACA,oCAAA;AAtKN;AA0KE;EACE,gBAAA;AAxKJ;;AA4KA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAzKF;AA2KE;EACE,gBAAA;EACA,WAAA;AAzKJ;AA4KE;EACE,yBAAA;AA1KJ;;AA+KA;EACE,oBAAA;AA5KF;AA8KE;EACE,oBAAA;AA5KJ;AA+KE;EACE,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA7KJ;;AAiLA;EACE,sBAAA;AA9KF;AAgLE;EACE,oBAAA;AA9KJ;AAmLI;EACE,eAAA;AAjLN;AAqLE;EACE,WAAA;EACA,iBAAA;EACA,UAAA;AAnLJ;AAwLI;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;AAtLN;;AA2LA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAxLF;AA0LE;EACE,aAAA;AAxLJ;AA0LI;EACE,yBAAA;AAxLN;AA4LI;EACE,mBAAA;EACA,oBAAA;AA1LN;;AA+LA;EACE,cAAA;EACA,eAAA;EACA,wEAAA;EACA,gBAAA;AA5LF;AA8LE;EANF;IAOI,iBAAA;EA3LF;AACF;AA6LE;EACE,wBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,wECrgFS;AD00Eb;AA6LI;EARF;IASI,WAAA;EA1LJ;AACF;;AAgME;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;AA7LJ;AA+LI;EAPF;IAQI,eAAA;EA5LJ;AACF;AA8LI;EACE,kBAAA;AA5LN;AA8LM;EACE,kBAAA;EACA,UAAA;AA5LR;AA8LQ;EAJF;IAKI,gBAAA;EA3LR;AACF;AA6LQ;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;AA3LV;AA8LQ;EACE,gBAAA;AA5LV;AAkMI;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AAhMN;AAkMM;EALF;IAMI,gBAAA;EA/LN;AACF;AAiMM;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AA/LR;AAiMQ;EATF;IAUI,gBAAA;EA9LR;AACF;;AAsME;EACE,SAAA;AAnMJ;;AAuMA;EACE,uBAAA;AApMF;;AAuMA;EACE,aAAA;AApMF;;AAuMA,mBAAA;AAcY;EAFF;IAGI,eAAA;EAhNZ;AACF;AAkNY;EANF;IAOI,eAAA;EA/MZ;AACF;AAiNY;EAVF;IAWI,eAAA;EA9MZ;AACF;AAuNU;EAFF;IAGI,kBAAA;EApNV;AACF;AAsNU;EANF;IAOI,kBAAA;IACA,UAAA;EAnNV;AACF;AA8NU;EAFF;IAGI,eAAA;EA3NV;AACF;AA6NU;EANF;IAOI,0BAAA;IACA,2BAAA;IACA,WAAA;IACA,0BAAA;EA1NV;AACF;AA+NM;EApBF;IAqBI,aAAA;EA5NN;AACF;AAqOU;EAFF;IAGI,gBAAA;EAlOV;AACF;;AA2OE;EACE,SAAA;AAxOJ","sourcesContent":["/* style-for-Profile-chart */\n\n// fonts\n@import './../../../assets/styles/variables';\n\n@import url('https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css');\n\n@font-face {\n  font-family: 'Conv_museo-500-webfont';\n  src: url($assets+'/fonts/museo-500-webfont.eot');\n  src: local('☺'), url($assets+'/fonts/museo-500-webfont.woff') format('woff'), url($assets+'/fonts/museo-500-webfont.ttf') format('truetype'), url($assets+'/fonts/museo-500-webfont.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n// vendor prefixes mixin\n@mixin prefix($property, $value, $prefixes: ()) {\n  @each $prefix in $prefixes {\n    #{'-' + $prefix + '-' + $property}: $value;\n  }\n\n  // Output standard non-prefixed declaration\n  #{$property}: $value;\n}\n\n/*========== mixin for animation ====================*/\n//Animations\n@mixin animation($animation) {\n  -webkit-animation: $animation;\n  -o-animation: $animation;\n  animation: $animation;\n}\n\n@mixin animation-name($name) {\n  -webkit-animation-name: $name;\n  animation-name: $name;\n}\n\n@mixin animation-duration($duration) {\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n}\n\n@mixin animation-timing-function($timing-function) {\n  -webkit-animation-timing-function: $timing-function;\n  animation-timing-function: $timing-function;\n}\n\n@mixin animation-delay($delay) {\n  -webkit-animation-delay: $delay;\n  animation-delay: $delay;\n}\n\n@mixin animation-iteration-count($iteration-count) {\n  -webkit-animation-iteration-count: $iteration-count;\n  animation-iteration-count: $iteration-count;\n}\n\n@mixin animation-direction($direction) {\n  -webkit-animation-direction: $direction;\n  animation-direction: $direction;\n}\n\n@mixin animation-fill-mode($fill-mode) {\n  -webkit-animation-fill-mode: $fill-mode;\n  animation-fill-mode: $fill-mode;\n}\n\n.chart-section {\n\n  //padding: 25px 0 43px 0;\n  // min-width: 580px;\n  width: 90%;\n  margin: 5% auto 0 auto;\n  padding-bottom: 20px;\n\n  /*------background colors used in chart---------*/\n  // .blue-bg {\n  //   background-color: $clarify-color !important;\n  // }\n  // .orange-bg {\n  //   background-color: $ideate-color !important;\n  // }\n  // .green-bg {\n  //   background-color: $develop-color !important;\n  // }\n  // .purple-bg {\n  //   background-color: $implement-color !important;\n  // }\n\n  /*------chart area wrapper---------*/\n\n  /*------main chart wrapper---------*/\n  .chart-main {\n    width: 100%;\n    height: 250px;\n    display: table;\n    border-collapse: collapse;\n    margin: 0 auto;\n    float: none;\n    position: relative;\n  }\n\n  /*------y dividers css---------*/\n  .y-dividers {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n    height: 100%;\n    //position: absolute;\n    left: 0px;\n    top: 0px;\n  }\n\n  @media screen and (-ms-high-contrast: active),\n  (-ms-high-contrast: none) {\n    .y-dividers {\n      position: absolute;\n    }\n  }\n\n  .dividers-yxis {\n    border-right: 1px solid #eee;\n    border-collapse: collapse;\n    display: table-cell;\n    width: 20%;\n    table-layout: fixed;\n    position: relative;\n  }\n\n  .dividers-yxis:first-child {\n    border-left: 1px solid #eee;\n  }\n\n  /*------x dividers css---------*/\n  .x-dividers {\n    display: block;\n    border-collapse: collapse;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    .owl-carousel & {\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden;\n    }\n  }\n\n  .dividers-xxis {\n    border-collapse: collapse;\n    width: 100%;\n    height: 20%;\n    border-bottom: 1px solid #eee;\n    position: relative;\n  }\n\n  .dividers-xxis:first-child {\n    border-top: 1px solid #eee;\n  }\n\n  /*------chart labels css---------*/\n  .side-label {\n    font-size: 16px;\n    color: rgba(0, 0, 0, .4) !important;\n    position: absolute;\n    left: -25px;\n    top: -8px;\n    text-align: right;\n    width: 20px;\n  }\n\n  .label-0 {\n    position: absolute;\n    top: inherit;\n    bottom: -8px;\n  }\n\n  /*------preferences css---------*/\n  .preference {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    padding: 0 30px;\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .high_prefer {\n    position: absolute;\n    top: 20px;\n    color: rgba(0, 0, 0, .4) !important;\n    left: 30px;\n  }\n\n  .low_prefer {\n    position: absolute;\n    bottom: 20px;\n    color: rgba(0, 0, 0, .4) !important;\n    left: 30px;\n  }\n\n  /*------neutral bar css---------*/\n  .neutral {\n    display: block;\n    margin-left: -30px;\n    margin-right: -30px;\n    background: $integrator-color !important;\n    position: absolute;\n    padding-left: 30px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    z-index: 1;\n    width: 100%;\n    height: 30px;\n    // -webkit-transform: translateY(-50%);\n    // -ms-transform: translateY(-50%);\n    // transform: translateY(-50%);\n    text-align: left;\n  }\n\n  .neutral span {\n    position: absolute;\n    left: 0;\n    font-size: 12px;\n  }\n\n  .neutral_high_value {\n    top: -15px;\n  }\n\n  .neutral_low_value {\n    bottom: -15px;\n  }\n\n  /*------chart titles css---------*/\n  .chart-title {\n    text-transform: uppercase;\n    font-size: 16px;\n    color: $color-light-type !important;\n    display: inline-block;\n    padding: 5px 0px;\n    width: 110px;\n    text-align: center;\n    position: absolute;\n    bottom: -31px;\n    right: -55px;\n    cursor: pointer;\n    z-index: 99;\n\n    html.mac.safari & {\n      bottom: -45px;\n    }\n  }\n\n  .chart-title.blue-bg:before,\n  .chart-title.orange-bg:before,\n  .chart-title.green-bg:before,\n  .chart-title.purple-bg:before {\n    content: \"\";\n    position: absolute;\n    top: -10px;\n    left: 0;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    line-height: 0px;\n    border-width: 0 55px 10px 55px;\n    _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');\n  }\n\n  // .chart-title.blue-bg:before {\n  //   border-color: transparent transparent $clarify-color transparent;\n  //   _border-color: #000000 #000000 $clarify-color #000000;\n  // }\n  // .chart-title.orange-bg:before {\n  //   border-color: transparent transparent $ideate-color transparent;\n  //   _border-color: #000000 #000000 $ideate-color #000000;\n  // }\n  // .chart-title.green-bg:before {\n  //   border-color: transparent transparent $develop-color transparent;\n  //   _border-color: #000000 #000000 $develop-color #000000;\n  // }\n  // .chart-title.purple-bg:before {\n  //   border-color: transparent transparent $implement-color transparent;\n  //   _border-color: #000000 #000000 $implement-color #000000;\n  // }\n\n  /*------chart pointers css---------*/\n  .chart_pointers {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n  }\n\n  .pointer {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    display: inline-block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    color: $color-light-type !important;\n    font-weight: 600;\n    font-size: 16px;\n    text-align: center;\n    line-height: 35px;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    margin-bottom: -35px;\n    font-weight: 600;\n    font-family: \"Helvetica LT W05 Bold\" !important;\n  }\n\n  .pointer.clarify_pointer {\n    left: -ms-calc(20% - 17px);\n    left: calc(20% - 17px);\n  }\n\n  .pointer.ideate_pointer {\n    left: -ms-calc(40% - 17px);\n    left: -o-calc(40% - 17px);\n    left: calc(40% - 17px);\n  }\n\n  .pointer.develop_pointer {\n    left: -ms-calc(60% - 17px);\n    left: -o-calc(60% - 17px);\n    left: calc(60% - 17px);\n  }\n\n  .pointer.implement_pointer {\n    left: -ms-calc(80% - 17px);\n    left: -o-calc(80% - 17px);\n    left: calc(80% - 17px);\n  }\n\n  /*------chart pointers css end---------*/\n\n  /*------connector css start---------*/\n  .connectors {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n\n  .connector_block {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 20%;\n    z-index: 4;\n  }\n\n  .block1 {\n    margin-left: 20%;\n  }\n\n  .block2 {\n    margin-left: 60%;\n  }\n\n  .block3 {\n    margin-left: 40%;\n  }\n\n  .connector_line {\n    position: absolute;\n    width: 8px;\n    margin-top: -15px;\n    background-color: $profile-connector-color !important;\n  }\n\n  .connector_point {\n    position: absolute;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 35px;\n    height: 35px;\n    margin-bottom: -35px;\n  }\n\n  #connector_clarify_pointer,\n  #connector_develop_pointer,\n  #mid_connector_1 {\n    left: -17px;\n  }\n\n  #connector_ideate_pointer,\n  #connector_implement_pointer,\n  #mid_connector_2 {\n    right: -17px;\n  }\n\n  /*------connector css end---------*/\n\n  .hidden-xs {\n    display: block;\n  }\n\n  .visible-xs {\n    display: none;\n  }\n\n  .chart-title.sm .visible-xs {\n    display: block !important;\n  }\n\n  .chart-title.sm .hidden-xs {\n    display: none !important;\n  }\n\n  .chart-title.sm {\n    width: 52px;\n    padding-left: 10px;\n    padding-right: 10px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    right: -25px;\n    text-transform: capitalize;\n    font-size: 14px;\n  }\n\n  .chart-title.blue-bg.sm:before,\n  .chart-title.orange-bg.sm:before,\n  .chart-title.green-bg.sm:before,\n  .chart-title.purple-bg.sm:before {\n    border-width: 0 26px 10px 26px;\n  }\n\n  @media only screen and (max-width: 689px) {\n    #chartarea {\n      min-width: 320px;\n      padding-left: 15px;\n    }\n\n    .chart-title {\n      width: 52px;\n      padding-left: 10px;\n      padding-right: 10px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      right: -25px;\n    }\n\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      border-width: 0 26px 10px 26px;\n    }\n\n    .chart-main {\n      height: 300px;\n      font-size: 14px;\n    }\n\n    .chart-title,\n    .side-label,\n    .pointer {\n      font-size: 14px;\n    }\n\n    .connector_line {\n      width: 5px;\n    }\n\n    .hidden-xs {\n      display: none;\n    }\n\n    .visible-xs {\n      display: block;\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .chart-main {\n      height: 280px;\n\n      ::ng-deep .result & {\n        height: 130px;\n        margin-bottom: 30px;\n      }\n\n      .preference {\n        font-size: 12px;\n      }\n\n      .high_prefer {\n        top: 5px;\n      }\n\n      .low_prefer {\n        bottom: 5px;\n      }\n    }\n\n    // .chart-title.sm{\n    //   width: 52px;\n    //   padding-left: 10px;\n    //   padding-right: 10px;\n    //   white-space: nowrap;\n    //   text-overflow: ellipsis;\n    //   right: -25px;\n    //   text-transform: capitalize;\n    //   font-size: 14px;\n    // }\n    // .chart-title.blue-bg.sm:before,\n    // .chart-title.orange-bg.sm:before,\n    // .chart-title.green-bg.sm:before,\n    // .chart-title.purple-bg.sm:before{\n    //   border-width: 0 26px 10px 26px;\n    // }\n\n    .chart-title {\n      width: 52px;\n      padding-left: 10px;\n      padding-right: 10px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      right: -25px;\n\n      body.mini-navbar & {\n        width: 40px !important;\n        right: -21px !important;\n      }\n    }\n\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      border-width: 0 26px 10px 26px;\n\n      body.mini-navbar & {\n        border-width: 0 20px 10px 20px !important;\n      }\n    }\n\n    .preference {\n      font-size: 14px;\n    }\n\n    .pointer {\n      -webkit-transform: translateY(-50%) scale(0.8);\n      -moz-transform: translateY(-50%) scale(0.8);\n      -ms-transform: translateY(-50%) scale(0.8);\n      -o-transform: translateY(-50%) scale(0.8);\n      transform: translateY(-50%) scale(0.8);\n    }\n  }\n\n  @media only screen and (max-width: 390px) {\n    #chartarea {\n      min-width: 250px;\n    }\n\n    .chart-title {\n      width: 40px;\n    }\n\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      border-width: 0 20px 10px 20px;\n    }\n  }\n\n  @media only screen and (max-height: 600px) {\n    .chart-main {\n      height: 250px;\n      font-size: 14px;\n    }\n\n    .chart-title,\n    .side-label,\n    .pointer {\n      font-size: 14px;\n    }\n\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      top: -10px;\n    }\n\n    .connector_line {\n      width: 5px;\n    }\n  }\n}\n\n.print-info {\n  display: block;\n  font-size: 10px;\n  margin-top: 5px;\n  color: $body-content-color;\n  margin-bottom: 5px;\n\n  a {\n    font-size: inherit !important;\n  }\n}\n\n#print-button {\n  // padding-bottom: 20px;\n  margin-bottom: -8px;\n\n  @media #{$mobile} {\n    margin: 0;\n    width: 100%;\n\n    select,\n    .btn {\n      width: 100%;\n    }\n  }\n\n}\n\n@media only screen and (max-height: 414px) and (orientation:landscape) {\n\n  .chart-title.sm {\n    width: 42px !important;\n    right: -21px !important;\n    font-size: 12px !important;\n  }\n\n  .chart-title.blue-bg.sm:before,\n  .chart-title.orange-bg.sm:before,\n  .chart-title.green-bg.sm:before,\n  .chart-title.purple-bg.sm:before {\n    border-width: 0 21px 10px 21px !important;\n  }\n}\n\n.chart-container,\n.below-chart {\n  padding: 25px;\n  max-width: 820px;\n  width: 100%;\n}\n\n#print-button a {\n  display: block;\n  font-size: 12px;\n  line-height: 1;\n  margin-bottom: 7px;\n  text-align: right;\n}\n\n.interpretive-wrapper {\n  max-width: 820px;\n  width: 100%;\n  font-family: \"Museo-regular\";\n  margin-block-start: -60px;\n}\n\n.interpretive-wrapper .toolsguide {\n  background: $color-light-type;\n}\n\nsection#four-profile {\n  padding: 0;\n}\n\n.toolsguide {\n  padding: 40px 40px 30px;\n}\n\n#four-profile .toolsguide-heading,\n#four-profile .toolsguide-content {\n  padding: 15px 30px;\n}\n\n.toolsguide .toolsguide-heading .toolsguide-heading-text {\n  font-size: 40px;\n  font-weight: 600;\n}\n\n#four-profile .toolsguide-heading,\n#four-profile .toolsguide-content {\n  padding: 15px 30px;\n}\n\n#four-think .box {\n  margin: 15px 1%;\n  min-height: 265px;\n}\n\n.toolsguide .box.clarify {\n  border: 1px solid $clarify-color !important;\n  box-shadow: 0 0 1px 0 $clarify-color !important;\n}\n\n#four-think .box h2 {\n  border-bottom: 1px solid;\n  box-shadow: 0 1px 1px -1px;\n  padding-bottom: 5px;\n}\n\n.toolsguide .box.clarify h2,\n.toolsguide .box.clarify h4 {\n  color: $clarify-color !important;\n}\n\n.toolsguide .box h2 {\n  font-size: 30px;\n}\n\n.toolsguide .toolsguide-content ul {\n  padding: 0;\n  list-style-position: inherit;\n  list-style-type: none;\n  font-family: \"Museo-300\";\n}\n\n.toolsguide .box ul {\n  margin: 0;\n  padding: 0;\n  list-style-position: inside;\n}\n\n.toolsguide .box ul li {\n  font-family: \"Museo-300\";\n  font-size: 14px;\n  line-height: 18px;\n  margin-bottom: 5px;\n}\n\n.toolsguide .toolsguide-content ul li {\n  font-family: \"Museo-300\";\n}\n\n.toolsguide .toolsguide-content ul li:before {\n  content: '\\2022';\n  margin-right: 5px;\n}\n\n.toolsguide .box.ideate {\n  border: 1px solid $ideate-color !important;\n  box-shadow: 0 0 1px 0 $ideate-color !important;\n}\n\n.toolsguide .box.ideate h2,\n.toolsguide .box.ideate h4 {\n  color: $ideate-color !important;\n}\n\n.toolsguide .box.develop {\n  border: 1px solid $develop-color !important;\n  box-shadow: 0 0 1px 0 $develop-color !important;\n}\n\n.toolsguide .box.develop h2,\n.toolsguide .box.develop h4 {\n  color: $develop-color !important;\n}\n\n.toolsguide .box.implement {\n  border: 1px solid $implement-color !important;\n  box-shadow: 0 0 1px 0 $implement-color !important;\n}\n\n.toolsguide .box.implement h2,\n.toolsguide .box.implement h4 {\n  color: $implement-color !important;\n}\n\n.toolsguide .toolsguide-heading .toolsguide-heading-text {\n  font-size: 40px;\n  font-weight: 600;\n}\n\n#four-box .box {\n  margin: 15px 1%;\n  min-height: 600px;\n}\n\n.toolsguide .box.clarify {\n  border: 1px solid $clarify-color !important;\n  box-shadow: 0 0 1px 0 $clarify-color !important;\n}\n\n.toolsguide .box .box-top {\n  padding: 15px;\n  margin: 0 -15px;\n}\n\n.toolsguide .box.clarify .box-top {\n  background: $clarify-color !important;\n}\n\n.toolsguide .toolsguide-content h4 {\n  font-size: 16px;\n}\n\n.toolsguide .box.ideate .box-top {\n  background: $ideate-color !important;\n}\n\n.toolsguide .box.develop .box-top {\n  background: $develop-color !important;\n}\n\n.toolsguide .box h2 img {\n  margin-left: 20px;\n}\n\n.toolsguide .box.implement .box-top {\n  background: $implement-color !important;\n}\n\n.toolsguide .toolsguide-content span.num {\n  font-size: 28px;\n  line-height: 20px;\n  margin-top: 6px;\n  display: block;\n  width: 20px;\n  float: left;\n}\n\n.toolsguide .toolsguide-content .num-p p {\n  float: right;\n  width: calc(100% - 30px);\n  font-size: 14px;\n}\n\n.toolsguide .toolsguide-content h3 {\n  font-size: 20px;\n}\n\n.pref {\n  margin-top: 15px;\n}\n\n.toolsguide .toolsguide-content h4 {\n  font-size: 16px;\n}\n\n.pref span {\n  padding: 2px 4px;\n  color: $color-light-type !important;\n  font-size: 14px;\n}\n\n.pref.clarify span {\n  background: $clarify-color !important;\n}\n\n.pref.clarify ul li {\n  color: $clarify-color !important;\n}\n\n.pref.ideate span {\n  background: $ideate-color !important;\n}\n\n.pref.ideate ul li {\n  color: $ideate-color !important;\n}\n\n.pref.developer span {\n  background: $develop-color !important;\n}\n\n.pref.developer ul li {\n  color: $develop-color !important;\n}\n\n.pref.implement span {\n  background: $implement-color !important;\n}\n\n.pref.implement ul li {\n  color: $implement-color !important;\n}\n\n.toolsguide .footer-xs {\n  background-color: #e6e7e8;\n  font-size: 12px !important;\n  padding: 10px 40px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n}\n\n.fs-graph-logo {\n  max-width: 300px;\n  width: 100%;\n}\n\n.below-chart .left-label {\n  background-color: $color-neutral-dark !important;\n  float: left;\n  font-size: 25px !important;\n  line-height: 30px;\n  letter-spacing: 0.8px;\n  padding: 5px 11px 5px 11px !important;\n  text-transform: none;\n  font-family: 'Helvetica LT W05 Bold';\n  margin-bottom: 0 !important;\n}\n\n.below-chart .right-label {\n  float: right;\n  margin-bottom: 0 !important;\n\n  .eq-developer {\n    margin-bottom: 0 !important;\n  }\n}\n\n.right-label-text span.eq-clarifier {\n  background-color: $clarify-color !important;\n  display: none;\n}\n\n.right-label-text span .icon-plus {\n  width: 32px;\n  font-size: 14px;\n  display: inline-block;\n  text-align: center;\n  color: #929394;\n  display: inline-block;\n  font: 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  @media (max-width:992px) {\n    width: 25px;\n  }\n}\n\n.right-label-text .icon-plus:before {\n  content: \"\\f067\";\n}\n\n.right-label-text .eq-developer {\n  background-color: $develop-color !important;\n}\n\n.below-chart span {\n  color: $color-light-type !important;\n  padding: 10px;\n}\n\n.right-label-text .eq-ideator {\n  background-color: $ideate-color !important;\n}\n\n.right-label-text .eq-implementer {\n  background-color: $implement-color !important;\n}\n\n\n@media (min-width: 768px) {\n  #four-think .box {\n    width: 48%;\n  }\n\n  #four-box .box {\n    width: 48%;\n  }\n}\n\n/*================= css copied from charts.scss ================*/\n// comparison-chart-1\n.comparison-chart-1 {\n  border-left: 1px solid #c0c0c0;\n  border-bottom: 1px solid #c0c0c0;\n  height: 200px;\n  position: relative;\n  margin-top: 50px;\n\n  ul {\n    padding: 0;\n    margin: 0;\n    display: flex;\n\n    li {\n      list-style: none;\n      width: 20%;\n      margin: 0 2.5%;\n      flex: 1;\n      position: absolute;\n      bottom: 0px;\n\n      span {\n        width: 50%;\n        display: block;\n        border: 0.5px solid $color-light-type;\n        float: left;\n        position: absolute;\n        bottom: 0;\n\n        .competitor-name {\n          color: $color-light-type;\n          font-size: 11px;\n          position: absolute;\n          bottom: 0px;\n          margin: 0px;\n          left: 2px;\n        }\n\n        .competitor-score {\n          text-align: center;\n          margin-top: -20px;\n        }\n      }\n\n      span:last-child {\n        margin-left: 50%;\n        opacity: 0.7;\n      }\n    }\n\n    .clarify-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n    }\n\n    &.remove-color .clarify-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n\n      span:last-child {\n        background-color: $color-neutral-mid !important;\n      }\n    }\n\n    .ideate-comparison {\n      margin-left: 25%;\n\n      span {\n        background-color: $ideate-color !important;\n      }\n    }\n\n    &.remove-color .ideate-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n\n      span:last-child {\n        background-color: $color-neutral-mid !important;\n      }\n    }\n\n    .develop-comparison {\n      margin-left: 50%;\n\n      span {\n        background-color: $develop-color !important;\n      }\n    }\n\n    &.remove-color .develop-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n\n      span:last-child {\n        background-color: $color-neutral-mid !important;\n      }\n    }\n\n    .implement-comparison {\n      margin-left: 75%;\n\n      span {\n        background-color: $implement-color !important;\n      }\n    }\n\n    &.remove-color .implement-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n\n      span:last-child {\n        background-color: $color-neutral-mid !important;\n      }\n    }\n  }\n}\n\n.client-detail {\n  .list-unstyled {\n    width: 100%;\n    float: left;\n    margin-bottom: 35px;\n\n    li {\n      //width: 50%;\n      //float:left;\n\n      @media screen and (max-width: 599px) {\n        width: 100%;\n      }\n\n      h2 {\n        font-size: 20px;\n        font-weight: bold;\n      }\n\n      span {\n        font-size: 18px;\n      }\n    }\n  }\n\n  .profile-headers {\n    clear: both;\n    float: left;\n    width: 100%;\n    margin: 30px 0;\n    font-size: 18px;\n    font-family: $font-museo;\n\n    @media(max-width:767px) {\n      font-size: 13px;\n    }\n\n    .profile-equation-wrapper {\n      font-family: $font-stack;\n\n      @media(max-width:950px) {\n        float: left !important;\n        clear: both;\n        margin-top: 10px;\n      }\n\n      @media(max-width:767px) {\n        float: right !important;\n        clear: none;\n      }\n\n      @media(max-width:599px) {\n        float: left !important;\n        clear: both;\n      }\n\n      span {\n        color: $color-light-type;\n        padding: 7px;\n\n        @media(max-width:950px) {\n          float: left;\n          margin-bottom: 10px;\n        }\n\n        @media(max-width:375px) {\n          display: block;\n        }\n      }\n\n      .eq-plus {\n        color: $color-neutral-dark;\n      }\n    }\n\n    .profile-equation-result {\n      background: $color-neutral-dark;\n      padding: 7px;\n      font-family: $font-stack;\n\n      a {\n        color: $color-light-type;\n        text-decoration: none;\n      }\n    }\n\n    .eq-clarifier,\n    .eq-ideator,\n    .eq-developer,\n    .eq-implementer {\n      //background-color: transparent;\n    }\n\n    .eq-clarifier {\n      //color: $clarify-color;\n    }\n\n    .eq-ideator {\n      //color:$ideate-color;\n    }\n\n    .eq-developer {\n      //color:$develop-color;\n    }\n\n    .eq-implementer {\n      //color: $implement-color;\n    }\n\n    //.right-label-text .icon-plus{\n    //  &:before{\n    //    content: \"&\";\n    //  }\n    //}\n\n  }\n\n  .client_description {\n    clear: both;\n    text-align: justify;\n    font-size: 16px;\n    margin-bottom: 30px;\n    -webkit-column-count: 2;\n    -ms-column-count: 2;\n    -moz-column-count: 2;\n    column-count: 2;\n    -webkit-column-gap: 20;\n    -ms-column-gap: 20;\n    -moz-column-gap: 20;\n    column-gap: 20;\n\n    @media screen and (max-width: 599px) {\n      -webkit-column-count: 1;\n      -ms-column-count: 1;\n      -moz-column-count: 1;\n      column-count: 1;\n      -webkit-column-gap: 0;\n      -ms-column-gap: 0;\n      -moz-column-gap: 0;\n      column-gap: 0;\n    }\n\n    span.pull-left {\n      padding-right: 10px;\n      padding-bottom: 10px;\n    }\n\n    span.profile-desc {\n      font-weight: bold;\n    }\n  }\n}\n\n.group-profile.teammates-group {\n  height: 230px;\n  border: none;\n  max-width: 90%;\n  margin: 0 auto;\n\n  .main-group-profile {\n    height: 230px;\n\n    .common-profile {\n      max-height: 50px;\n    }\n\n    .integrators-region {\n      height: 30px;\n      margin-top: -15px;\n\n      h4 {\n        line-height: 30px;\n      }\n    }\n\n    .profile-flex-bottom {\n      margin-top: 15px;\n\n      .common-low {\n        h5 {\n          margin: 0px;\n          margin-top: 5px;\n        }\n      }\n    }\n\n    .profile-flex-top {\n      .common-high {\n        .top-label-scores {\n          margin: 0;\n          margin-bottom: 5px;\n        }\n      }\n    }\n  }\n}\n\n// comparison-chart-2\n.comparison-chart-2 {\n  border-left: 1px solid #c0c0c0;\n  border-bottom: 1px solid #c0c0c0;\n  height: 200px;\n  position: relative;\n\n  .diff-score {\n    position: absolute;\n    color: #333;\n    top: -20px;\n  }\n\n  .other-User {\n    .diff-score {\n      right: -3px;\n    }\n  }\n\n  .current-User {\n    .diff-score {\n      left: -3px;\n    }\n  }\n\n  .score_calculator {\n    position: absolute;\n    top: 0;\n    left: -20px;\n    bottom: 0;\n    width: 20px;\n\n    .start,\n    .end {\n      position: absolute;\n    }\n\n    .start {\n      bottom: -5px;\n      left: 7px;\n    }\n\n    .end {\n      top: -5px;\n    }\n\n  }\n\n  ul {\n    padding: 0;\n    margin: 0 0 0 4.5%;\n    display: flex;\n    opacity: 0;\n    @include animation-fill-mode(forwards);\n    @include animation-name(chartOpacity);\n    @include animation-duration(3s);\n    @include animation-timing-function(ease);\n    @include animation-delay(2000ms);\n\n    li {\n      list-style: none;\n      width: 20%;\n      margin: 0;\n      flex: 1;\n      position: absolute;\n      bottom: 0px;\n\n      span {\n        width: 50%;\n        display: block;\n        border: 0.5px solid #000;\n        float: left;\n        position: absolute;\n        bottom: 0;\n        z-index: 1;\n        @include prefix(box-shadow, 2px 1px 5px rgba(0, 0, 0, 0.35), webkit ms moz o);\n\n        .competitor-name {\n          color: $color-light-type;\n          font-size: 11px;\n          position: absolute;\n          bottom: 0px;\n          margin: 0px;\n          left: 2px;\n        }\n\n        .competitor-score {\n          text-align: left;\n          margin-top: 2px;\n          color: $color-light-type;\n          margin-left: 3px;\n          margin-right: 3px;\n        }\n      }\n\n      span:last-child {\n        opacity: 0.7;\n        z-index: 0;\n        left: 30%;\n        @include prefix(box-shadow, none, webkit ms moz o);\n\n        .competitor-name {\n          right: 5px;\n          left: inherit;\n          text-align: right;\n        }\n\n        .competitor-score {\n          text-align: right;\n        }\n      }\n    }\n\n    .clarify-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n    }\n\n    .ideate-comparison {\n      margin-left: 25%;\n\n      span {\n        background-color: $ideate-color !important;\n      }\n    }\n\n    .develop-comparison {\n      margin-left: 50%;\n\n      span {\n        background-color: $develop-color !important;\n      }\n    }\n\n    .implement-comparison {\n      margin-left: 75%;\n\n      span {\n        background-color: $implement-color !important;\n      }\n    }\n  }\n}\n\n// Chart 3\n$base: 0%;\n$data-1: 25%;\n$data-2: 55%;\n$data-3: 35%;\n$data-4: 50%;\n$data-5: 10%;\n$data-6: 30%;\n$data-7: 0%;\n$data-8: 40%;\n\n.grid {\n  border-left: 1px solid #000;\n  box-shadow: 0px 1px 0 rgba(0, 0, 0, 1);\n  border-top: 0;\n  border-bottom: 0;\n  width: 100%;\n  max-width: 700px;\n  height: 200px;\n  margin: 50px auto;\n  position: relative;\n\n  .score_calculator {\n    position: absolute;\n    top: 0;\n    left: -20px;\n    bottom: 0;\n    width: 20px;\n\n    .start,\n    .end {\n      position: absolute;\n    }\n\n    .start {\n      bottom: -5px;\n      left: 7px;\n    }\n\n    .end {\n      top: -5px;\n    }\n\n  }\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n    position: relative;\n\n    li {\n      width: 25%;\n      position: absolute;\n      left: 0px;\n      bottom: 0;\n      top: 0px;\n\n      .commonGraph {\n        opacity: .65;\n        width: 100%;\n        height: 100%;\n        position: relative;\n        @include prefix(transition, all 400ms ease-in-out, webkit ms moz);\n\n        &:hover {\n          opacity: .8;\n        }\n      }\n\n      .graph {\n        z-index: 1;\n      }\n\n      .graph2 {\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        z-index: 1;\n      }\n\n      &.clarify-comparison {\n\n        .graph,\n        .graph2 {\n          background: $clarify-color;\n        }\n\n        //.graph{\n        //  clip-path: polygon(\n        //    0% $base,\n        //    100% $data-1,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $base,\n        //    100% $data-1,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n        //\n        //.graph2{\n        //  clip-path: polygon(\n        //    0% $base,\n        //    100% $data-2,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $base,\n        //    100% $data-2,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n\n      }\n\n      &.ideate-comparison {\n        left: 25%;\n\n        .graph,\n        .graph2 {\n          background: $ideate-color;\n        }\n\n        //.graph{\n        //  clip-path: polygon(\n        //    0% $data-1,\n        //    100% $data-3,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-1,\n        //    100% $data-3,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n        //.graph2{\n        //  clip-path: polygon(\n        //    0% $data-2,\n        //    100% $data-4,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-2,\n        //    100% $data-4,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n\n      }\n\n      &.develop-comparison {\n        left: 50%;\n\n        .graph,\n        .graph2 {\n          background: $develop-color;\n        }\n\n        //.graph{\n        //  clip-path: polygon(\n        //    0% $data-3,\n        //    100% $data-5,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-3,\n        //    100% $data-5,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n        //.graph2{\n        //  clip-path: polygon(\n        //    0% $data-4,\n        //    100% $data-6,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-4,\n        //    100% $data-6,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n      }\n\n      &.implement-comparison {\n        left: 75%;\n\n        .graph,\n        .graph2 {\n          background: $implement-color;\n        }\n\n        //.graph{\n        //  clip-path: polygon(\n        //    0% $data-5,\n        //    100% $data-7,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-5,\n        //    100% $data-7,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n        //.graph2{\n        //  clip-path: polygon(\n        //    0% $data-6,\n        //    100% $data-8,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-6,\n        //    100% $data-8,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n      }\n    }\n  }\n}\n\n::ng-deep .profile-section {\n\n  &.chart-container {\n\n    &__pd {\n      padding: 0 !important;\n      box-shadow: none !important;\n\n      &>h2 .form-inline {\n\n        @media #{$mobile} {\n          margin-top: 20px;\n        }\n\n        input+input {\n          margin-top: 10px;\n        }\n      }\n\n      &>h2 {\n\n        display: flex;\n        flex-direction: column-reverse;\n\n        span {\n\n          @media #{$mobile-up} {\n            text-align: right;\n          }\n        }\n\n      }\n\n      .chart-section {\n        margin: 0 0 0 29px;\n        width: 96.5%;\n      }\n\n    }\n  }\n\n  .chart-section {\n    margin-top: 0;\n\n    .side-label {\n      font-size: 12px;\n      line-height: 14px;\n      color: #999999 !important;\n      position: absolute;\n      left: -35px !important;\n      text-align: right;\n      width: 20px;\n      letter-spacing: 0.01px;\n      font-family: \"Helvetica LT W05 Light\";\n    }\n\n    .high_prefer {\n      position: absolute;\n      top: 2px !important;\n      left: 9px !important;\n      width: 110px;\n      font-weight: normal;\n      font-size: 14px !important;\n      line-height: 17px !important;\n      font-family: \"Helvetica LT W05 Roman\";\n      text-align: left;\n      color: #5C5D60 !important;\n    }\n\n    .low_prefer {\n      position: absolute;\n      bottom: 20px;\n      left: 9px;\n      font-size: 14px;\n      line-height: 17px;\n      width: 110px;\n      text-align: left;\n      font-family: \"Helvetica LT W05 Roman\";\n      color: #5C5D60 !important;\n    }\n\n    .neutral .neutralBartext {\n      left: 9px !important;\n      position: absolute;\n      font-weight: normal;\n      font-size: 14px !important;\n      line-height: 17px !important;\n      font-family: \"Helvetica LT W05 Roman\";\n      color: #5C5D60 !important;\n    }\n\n    .neutral_high_value {\n      font-size: 14px !important;\n      font-weight: normal;\n      line-height: 17px !important;\n      font-family: \"Helvetica LT W05 Roman\";\n      color: #999 !important;\n      left: 9px !important;\n    }\n\n    .neutral_low_value {\n      font-size: 14px !important;\n      font-weight: normal;\n      line-height: 17px !important;\n      font-family: \"Helvetica LT W05 Roman\";\n      color: #999 !important;\n      left: 9px !important;\n    }\n\n    .chart-main {\n      .chart-title span {\n        font-size: 11px !important;\n        line-height: 14px;\n        font-family: 'Helvetica LT W05 Bold';\n      }\n\n      @media only screen and (max-width:1023px) {\n        .visible-xs {\n          display: block !important;\n        }\n\n        .hidden-xs {\n          display: none !important;\n        }\n\n        .chart-title.blue-bg:before,\n        .chart-title.orange-bg:before,\n        .chart-title.green-bg:before,\n        .chart-title.purple-bg:before {\n          border-width: 0 26px 10px 26px;\n        }\n\n        .chart-title {\n          width: 52px;\n          padding-left: 10px;\n          padding-right: 10px;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          right: -25px;\n          text-transform: capitalize;\n          font-size: 14px;\n        }\n      }\n\n      @media(min-width:768px) {\n        height: 350px;\n      }\n    }\n  }\n}\n\n::ng-deep #f-profile {\n  .chart-section {\n    .chart-main {\n      @media(max-width:1023px) {\n        .visible-xs {\n          display: block !important;\n        }\n\n        .hidden-xs {\n          display: none !important;\n        }\n\n        .chart-title.blue-bg:before,\n        .chart-title.orange-bg:before,\n        .chart-title.green-bg:before,\n        .chart-title.purple-bg:before {\n          border-width: 0 26px 10px 26px;\n        }\n\n        .chart-title {\n          width: 52px;\n          padding-left: 10px;\n          padding-right: 10px;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          right: -25px;\n          text-transform: capitalize;\n          font-size: 14px;\n        }\n      }\n\n      @media(max-width:767px) {\n        height: 235px;\n      }\n    }\n  }\n}\n\n::ng-deep .below-chart-description {\n  background-color: $color-neutral-dark !important;\n  color: $color-light-type;\n  padding: 25px 25px 0;\n  max-width: 820px;\n  width: 100%;\n\n  .height30 {\n    height: 30px;\n  }\n\n  .custom-footer {\n    margin-left: -25px;\n    margin-right: -25px;\n    background: $color-light-type;\n    color: $body-content-color;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    vertical-align: middle;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 15px 0px;\n\n    @media(max-width:767px) {\n      display: block;\n      float: left;\n\n      .col-xs-12 {\n        text-align: center !important;\n        margin-bottom: 10px;\n      }\n    }\n\n    p {\n      margin: 0;\n      font-size: 12px !important;\n      color: #5C5D60 !important;\n    }\n\n    a {\n      font-size: 12px !important;\n    }\n\n  }\n}\n\n.quick-gd {\n  width: 100%;\n  max-width: 820px;\n  position: relative;\n  margin-block-start: -15px;\n\n  .quick-gd__arrow {\n    border-left: 70px solid transparent;\n    border-right: 70px solid transparent;\n    border-top: 60px solid #7bbc43;\n    max-width: 100px;\n    position: relative;\n    width: 100%;\n    min-height: 100px;\n    margin: 21px auto;\n    cursor: pointer;\n\n    span {\n      position: absolute;\n      top: -60px;\n      left: -20px;\n      z-index: 9;\n      max-width: 50px;\n      font-size: 14px;\n      font-weight: bold;\n      color: #fff;\n    }\n  }\n}\n\n#build-term {\n  .toolsguide-heading {\n    min-height: 90px;\n  }\n\n  .lg-text {\n    font-size: 18px;\n    margin-bottom: 15px;\n  }\n\n  .side-bar {\n    background: #e6e7e9 !important;\n    padding: 20px;\n  }\n}\n\n#four-box .box {\n  @media(min-width:768px) {\n    width: 48%;\n  }\n\n  margin:15px 1%;\n  min-height:600px;\n\n  .col-xs-6 {\n    &:first-child {\n      padding-right: 7.5px;\n    }\n\n    &:last-child {\n      padding-left: 7.5px;\n    }\n  }\n}\n\n\n.right-button {\n  &.text-right {\n    width: 100%;\n    text-align: center;\n    margin: 3px 0 8px 0;\n\n    a.btn {\n      /*width: 230px;*/\n      display: block;\n    }\n  }\n\n  &.disable-btn {\n    a {\n      cursor: not-allowed;\n    }\n  }\n\n}\n\n.d-block {\n  display: block;\n}\n\n.no-bottom-pad {\n  // padding-bottom: 0px;\n\n  h5 {\n    font-size: 17px;\n  }\n\n  .close {\n    margin-top: -24px;\n  }\n}\n\n.modal-dialog {\n  width: 470px;\n}\n\n@media print {\n\n  /*#chartarea {\n      width: 580px;\n    }*/\n  .chart-title {\n    color: $color-light-type$color-light-type !important;\n\n    .visible-xs,\n    .hidden-xs {\n      color: $color-light-type$color-light-type !important;\n    }\n  }\n\n  /* Guide Report print style*/\n\n  body {\n    color: $body-content-color !important;\n  }\n\n  .below-chart,\n  .below-chart-description {\n    margin-left: 20px;\n\n  }\n\n  .below-chart-description {\n\n    p,\n    big,\n    a,\n    span,\n    sup {\n      color: $color-light-type !important;\n    }\n  }\n\n  .chart-container {\n    padding-top: 0px;\n    margin-bottom: 20px;\n  }\n\n  .short-guide,\n  .long-guide {\n    .innovation-section {\n      margin: 0px auto;\n      padding: 15px 15px 50px;\n      min-height: 960px;\n    }\n\n    #four-profile {\n      padding-top: 0;\n\n      .toolsguide-heading {\n        padding: 0px;\n      }\n\n      .toolsguide-content {\n        padding: 0;\n      }\n    }\n\n    #four-box .box {\n      min-height: 430px;\n      margin: 0px 1% 15px;\n\n      .box-top {\n        img {\n          width: 55px;\n        }\n      }\n\n      h2 {\n        margin: 5px 0;\n      }\n\n      .col-xs-6:first-child {\n        padding: 0px 7.5px;\n      }\n\n      ul li {\n        line-height: 16px;\n      }\n    }\n\n    #four-think .box {\n      min-height: 225px;\n      margin: 2px;\n    }\n\n    #dots-img {\n      background: url($assets+\"/images/dotk.jpg\") !important;\n      background-size: cover !important;\n      min-height: 900px;\n    }\n\n    .toolsguide .box .box-top {\n      padding: 0px 15px;\n    }\n\n    #four-think .box h2 {\n      margin: 5px 0;\n    }\n\n    .toolsguide {\n      page-break-after: always;\n\n      &:last-child {\n        page-break-after: auto;\n      }\n\n      .toolsguide-content aside {\n        padding: 0px;\n      }\n\n      .footer-lg {\n        background-color: $color-neutral-dark !important;\n\n        .text,\n        a {\n          color: $color-light-type !important;\n        }\n\n        a[href]:after {\n          color: $color-light-type !important;\n        }\n      }\n\n      .pref.clarify span {\n        background: #00aed9 !important;\n        ;\n      }\n\n      .pref.ideate span {\n        background: #f68c1f !important;\n      }\n\n      .pref.developer span {\n        background: #66bd4a !important;\n      }\n\n      .pref.implement span {\n        background: #ef465b !important;\n      }\n\n      .pref.clarify ul li {\n        color: #00aed9 !important;\n      }\n\n      .pref.developer ul li {\n        color: #66bd4a !important;\n      }\n\n      .pref.ideate ul li {\n        color: #f68c1f !important;\n      }\n\n      .pref.implement ul li {\n        color: #ef465b !important;\n      }\n\n      .toolsguide-heading-text {\n        margin: 0px;\n      }\n\n      .footer-xs {\n        background-color: #e6e7e8 !important;\n      }\n\n      .box.clarify {\n\n        h2,\n        h4 {\n          color: #00aed9 !important;\n        }\n\n        .box-top {\n          background-color: #00aed9 !important;\n        }\n      }\n\n      .box.ideate {\n\n        h2,\n        h4 {\n          color: #f68c1f !important;\n        }\n\n        .box-top {\n          background-color: #f68c1f !important;\n        }\n      }\n\n      .box.develop {\n\n        h2,\n        h4 {\n          color: #66bd4a !important;\n        }\n\n        .box-top {\n          background-color: #66bd4a !important;\n        }\n      }\n\n      .box.implement {\n\n        h2,\n        h4 {\n          color: #ef465b !important;\n        }\n\n        .box-top {\n          background-color: #ef465b !important;\n        }\n      }\n\n      .box ul li {\n        margin-bottom: 0px;\n      }\n    }\n  }\n}\n\n.profile-section h2 {\n  color: #5C5D60;\n  font-size: 32px;\n  margin: 0 0 0;\n  letter-spacing: -0.1px;\n  font-family: 'Helvetica LT W05 Bold';\n}\n\n.profile-section p {\n  font-size: 12px !important;\n  color: #5C5D60 !important;\n  margin-bottom: 0;\n}\n\n.form-inline .fa,\n.pencil .fa {\n  font-size: 18px;\n}\n\n.grey {\n  background: rgba(236, 236, 236, 0.9);\n}\n\n.download_language {\n  margin-top: 20px;\n  font-size: 13px;\n}\n\n.long_guides {\n  margin-top: 20px;\n}\n\n.package-form {\n  display: inline-block;\n  width: 100%;\n\n  &--pd {\n\n    .modal-body {\n\n      select {\n        padding: 5px !important;\n      }\n    }\n  }\n\n  label,\n  select {\n    width: 55%;\n  }\n\n  label {\n    line-height: 2em;\n    padding: .75rem .75rem .75rem 0 !important;\n  }\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n    margin-bottom: 10px;\n  }\n\n  select:focus {\n    outline: none;\n  }\n\n  .modal-body .warning {\n    padding-top: 10px;\n  }\n}\n\n.package-form .btn {\n  margin-top: 10px\n}\n\n.profile-description {\n  color: #5C5D60 !important;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.4px;\n  font-family: 'Helvetica LT W05 Roman';\n  margin-top: 13px;\n}\n\n.below-chart {\n  background: #f1f1f1;\n  margin-bottom: 0;\n\n  h3 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    grid-gap: 10px 13px;\n\n    .left-label {\n      float: none;\n      // margin-right: 13px !important;\n      // margin-bottom: 10px !important;\n    }\n\n    .prefers_to {\n      font-family: 'Helvetica LT W05 Roman';\n      color: #5C5D60 !important;\n      font-size: 14px !important;\n      line-height: 17px !important;\n      text-transform: none;\n      letter-spacing: -0.04px;\n      font-weight: normal;\n      display: inline;\n      margin-bottom: 0 !important;\n    }\n\n    #equation {\n      display: inline-block;\n      // padding-left: 13px;\n\n      span {        \n        margin-bottom: 0 !important\n      }\n\n      &>span {\n        padding: 0;\n        display: inline-block !important;\n        font-size: 12px !important;\n        font-weight: 400 !important;\n        line-height: 14px !important;\n        text-transform: uppercase !important;\n        font-family: 'Helvetica LT W05 Bold' !important;\n        letter-spacing: 0.07px !important;;\n      }\n    }\n  }\n}\n\n.footer-logo {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  width: 100%;\n  margin-bottom: 10px;\n\n  .copyright {\n    width: 50%;\n\n    p {\n      font-size: 11px !important;\n      letter-spacing: 0.39px !important;\n    }\n  }\n\n  .fs-logo {\n    width: 50%;\n    text-align: right;\n  }\n}\n\n.below-chart-description {\n  margin-bottom: 0;\n\n  p {\n    margin: 0;\n    font-family: 'Helvetica LT W05 Light';\n    font-size: 12px;\n    line-height: 17px;\n    display: block;\n    color: #f1f1f1;\n\n    span {\n      font-size: 14px;\n      font-family: 'Helvetica LT W05 Bold';\n    }\n  }\n\n  .fs-graph-logo {\n    max-width: 181px;\n  }\n}\n\n.fixed-loader {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n\n  &.profile-loader {\n    max-width: 820px;\n    width: 100%;\n  }\n\n  i {\n    font-size: 8em !important;\n  }\n\n}\n\n.pf-rdbtn {\n  padding-bottom: 25px;\n\n  &--pfpdf {\n    padding-bottom: 10px;\n  }\n\n  label {\n    padding: 0;\n    width: 65%;\n    padding-left: 10px;\n    font-weight: 500;\n    cursor: pointer;\n  }\n}\n\n.modal-body {\n  padding-block-end: 0px;\n\n  .disable-btn {\n    pointer-events: none;\n  }\n\n  .text-left {\n\n    &.text {\n      padding-left: 0;\n    }\n  }\n\n  .text--fw {\n    width: 100%;\n    font-weight: bold;\n    padding: 0;\n  }\n\n  .assessment-select {\n\n    select {\n      height: 30px;\n      padding: 3px;\n      width: 45%;\n      background-color: #fff;\n      margin: 0 10px 7px;\n    }\n  }\n}\n\n.modal-body__buttons {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  border-top: 1px solid #ddd;\n  width: calc(100% + 32px);\n  margin: 0 -16px;\n  padding: 5px 10px;\n  background-color: #f6f6f6;\n\n  .btn {\n    margin-top: 0;\n\n    &-prim {\n      margin-inline-start: 10px;\n\n    }\n\n    &-disable {\n      cursor: not-allowed;\n      pointer-events: none;\n    }\n  }\n}\n\n.clr {\n  color: #5C5D60;\n  font-size: 16px;\n  font-family: \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 400;\n\n  @media #{$mobile} {\n    padding-bottom: 0;\n  }\n\n  select {\n    padding: 2px 5px 2px 3px;\n    outline-color: #5c5d60;\n    width: 171px;\n    height: 29px;\n    color: #5c5d60;\n    font-family: $font-stack;\n\n    @media #{$mobile} {\n      width: 100%;\n    }\n  }\n}\n\n.chart-container {\n\n  .chart-pfd {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    line-height: 20px;\n    align-items: center;\n\n    @media #{$mobile} {\n      flex-wrap: wrap;\n    }\n\n    .chart-left {\n      position: relative;\n\n      &__title {\n        position: absolute;\n        top: -55px;\n\n        @media #{$mobile} {\n          position: static;\n        }\n\n        strong {\n          padding-bottom: 8px;\n          color: #5C5D60;\n          font-size: 32px;\n          line-height: 38px;\n          margin: 0 0 0;\n          letter-spacing: -0.1px;\n          font-family: \"Helvetica LT W05 Bold\";\n        }\n\n        .pencil {\n          margin-left: 8px;\n        }\n\n      }\n    }\n\n    .chart-right {\n      width: 100%;\n      text-align: right;\n      padding-bottom: 6px;\n\n      @media #{$mobile} {\n        text-align: left;\n      }\n\n      .foursight-content {\n        font-size: 16px;\n        line-height: 19px;\n        text-align: right;\n        margin-bottom: 0px;\n        margin-top: 11px;\n        letter-spacing: 0;\n        padding-bottom: 0;\n\n        @media #{$mobile} {\n          text-align: left;\n        }\n      }\n    }\n  }\n}\n\n.chartist-wrap {\n\n  &__pd {\n    margin: 0;\n  }\n}\n\n.section-wrapper {\n  padding: 20px 10px 40px;\n}\n\n.guide-modal {\n  display: none;\n}\n\n/*--- 05-07-23 ---*/\n\n.fs-profile {\n\n  .page-content {\n\n    .chart-container {\n\n      .chart-left {\n\n        &__title {\n\n          h2 {\n\n            @media #{$pc} {\n              font-size: 30px;\n            }\n\n            @media (min-width: 768px) and (max-width: 991px) {\n              font-size: 28px;\n            }\n\n            @media (max-width: 640px) {\n              font-size: 26px;\n            }\n          }\n        }\n      }\n\n      ::ng-deep &__pd {\n\n        .chart-section {\n\n          @media (min-width: 641px) and (max-width: 991px) {\n            margin: 0 0 0 19px;\n          }\n\n          @media (max-width: 640px) {\n            margin: 0 0 0 19px;\n            width: 95%;\n          }\n        }\n      }\n    }\n\n    .below-chart {\n\n      h3 {\n\n        .left-label {\n\n          @media (min-width: 768px) and (max-width: 991px) {\n            font-size: 22px;\n          }\n\n          @media (max-width: 640px) {\n            font-size: 18px !important;\n            padding: 4px 8px !important;\n            width: 100%;\n            margin-right: 0 !important;\n          }\n\n        }\n      }\n\n      @media (max-width: 640px) {\n        padding: 18px;\n      }\n    }\n\n    .quick-gd {\n\n      & .quick-gd {\n\n        &__arrow {\n\n          @media #{$pc} {\n            min-height: 75px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.f-btn {\n  \n  &--nobdr  {\n    border: 0; \n  }\n}","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
